// K85Report/k85form.template.js
// АВТО-ЗГЕНЕРОВАНО з докладного HTML-шаблону форми 85-К (наказ МОН №1084 від 29.07.2025).
// Кожна комірка даних несе data-k85="<КЛЮЧ_ЗВІТУ>" (напр. CHwork10001, PR301, OOP11),
// а прапорці Розділу А — data-k85chk="<КЛЮЧ>". Значення підставляються у K85Report.jsx
// з об'єкта report[КЛЮЧ]. Не редагуйте вручну — правки робіть у генераторі.
const K85_FORM_HTML = `<div class="rvps4" style="float: right">
    <div class="order_head">
        <p>ЗАТВЕРДЖЕНО</p>
        <p>Наказ Міністерства</p>
        <p>освіти і науки України</p>
        <p>29 липня 2025 року № 1084</p>
    </div>
</div>
<div style="clear: both"></div>

<p class="rvps8"><span class="rvts8" style="font-size: 14pt;">Звітність</span></p>
<p class="rvps8"><span class="rvts8" style="font-size: 14pt;">Звіт <br>про діяльність закладу дошкільної освіти</span></p>
<p class="rvps9"><span class="rvts8">за <span data-k85="year">\u00A0</span></span><span class="rvts8" id="Zvit_YY"> рік</span></p>
<br>
<div class="rvps7" align="center">
    <table width="100%" border="1" cellpadding="4" cellspacing="-1" style="border-width: 0px; border-collapse: collapse;">
        <tbody><tr valign="top">
            <td height="19" valign="middle"><p class="rvps1"><span class="rvts7">Подають:</span></p></td>
            <td height="19" valign="middle"><p class="rvps1"><span class="rvts7">Термін подання</span></p></td>
            <td height="19" valign="middle" rowspan="3">
                <p class="rvps1"><span class="rvts7"><b>Форма № 85-К</b><br>(річна)<br><br>ЗАТВЕРДЖЕНО<br>Наказ Міністерства<br>освіти і науки України<br>__ _____ 2025 року № ___</span></p>
                <br><p class="rvps1"><span class="rvts7">за погодженням з <br>Держстатом</span></p>
            </td>
        </tr>
        <tr valign="top">
            <td valign="middle" class="tal">
                <p>
                            <span class="rvts7">Юридичні особи, відокремлені підрозділи юридичних осіб, структурні <br>
                                підрозділи юридичних осіб, фізичні особи – підприємці, які <br>
                                провадять освітню діяльність у сфері дошкільної освіти – <br>
                                Державній науковій установі <br>
                                «Інститут освітньої аналітики»
                            </span>
                </p>
            </td>
            <td valign="middle" width="150px">
                <p class="rvps1"><span class="rvts7">не пізніше, ніж<br>28 лютого року, <br>наступного за звітним</span></p><br>
            </td>
        </tr>
        <tr valign="top">
            <td valign="middle" class="tal">
                <p>
                            <span class="rvts7">Державна наукова установа <br>
                                «Інститут освітньої аналітики» – <br>
                                Міністерству освіти і науки України
                            </span>
                </p>
            </td>
            <td valign="middle">
                <p class="rvps1"><span class="rvts7">не пізніше, ніж<br>01 квітня року, <br>наступного за звітним</span></p><br>
            </td>
        </tr>
    </tbody></table>
</div>
<br>

<div align="center">
    <table border="0" cellspacing="0" cellpadding="0" class="fs-1" style="width: 99%;">
        <tbody><tr>
            <td width="100%" valign="TOP" height="17" style="border-bottom:solid 0px #000000; border-top:solid 0px #000000; padding-left: 7px;" class="tal"><b>Респондент:</b></td>
        </tr>
        <tr>
            <td width="100%" valign="LEFT" height="17" style="border-bottom:solid 0px #000000; border-top:solid 0px #000000; padding-left: 7px; padding-bottom: 4px;" class="tal">
                <table class="number-boxes" cellspacing="0" cellpadding="0">
                    <tbody><tr>
                        <td><span data-k85="edr1">&nbsp;</span></td>
                        <td><span data-k85="edr2">&nbsp;</span></td>
                        <td><span data-k85="edr3">&nbsp;</span></td>
                        <td><span data-k85="edr4">&nbsp;</span></td>
                        <td><span data-k85="edr5">&nbsp;</span></td>
                        <td><span data-k85="edr6">&nbsp;</span></td>
                        <td><span data-k85="edr7">&nbsp;</span></td>
                        <td><span data-k85="edr8">&nbsp;</span></td>
                        <td><span data-k85="edr9">&nbsp;</span></td>
                        <td><span data-k85="edr10">&nbsp;</span></td>
                    </tr>
                </tbody></table>
            </td>
        </tr>
        <tr>
            <td width="100%" valign="TOP" height="17" style="border-bottom:solid 0px #000000; border-top:solid 0px #000000; padding-left: 7px; padding-bottom: 4px;" class="tal">
                <span style="font-size: 8px;">
                    Зазначається код за ЄДРПОУ або реєстраційний (обліковий) номер платника податків, який присвоюється
                    контролюючими органами, або реєстраційний номер облікової картки платника податків - фізичної особи.
                    Серію (за наявності) та номер паспорта зазначають фізичні особи, які через свої релігійні переконання
                    відмовляються від прийняття реєстраційного номера облікової картки платника податків та офіційно
                    повідомили про це відповідний контролюючий орган і мають відмітку у паспорті.
                </span>
            </td>
        </tr>
        <tr>
            <td width="100%" valign="BOTTOM" class="nbb">
                <table border="0" cellspacing="0" cellpadding="0" width="100%" class="nb">
                    <tbody><tr>
                        <td class="tal nb">Найменування юридичної особи/прізвище, ім’я, по батькові (за наявності) фізичної особи:</td>
                        <td class="tal bb" width="32%"></td>
                    </tr>
                </tbody></table>
            </td>
        </tr>
        <tr>
            <td width="96%" valign="TOP" class="nbb">
                <table border="0" cellspacing="0" cellpadding="0" width="100%" class="nb">
                    <tbody><tr>
                        <td class="tal bb">
                        </td>
                        <td class="bb" width="95%" height="23">
                            <span data-k85="name_kg">&nbsp;</span>
                        </td>
                    </tr>
                </tbody></table>
            </td>
        </tr>
        <tr>
            <td width="100%" valign="BOTTOM" class="nbb">
                <table border="0" cellspacing="0" cellpadding="0" width="100%" class="nb">
                    <tbody><tr>
                        <td class="tal  nb">
                            <nobr>Місцезнаходження/ Місце проживання:</nobr>
                        </td>
                        <td class="tal bb" height="23" width="68%"><span data-k85="addr_kg_yur">&nbsp;</span></td>
                    </tr>
                </tbody></table>
            </td>
        </tr>
        <tr>
            <td width="96%" valign="TOP" class="nbb">
                <table border="0" cellspacing="0" cellpadding="0" width="100%" class="nb">
                    <tbody><tr>
                        <td class="tal bb">
                            <nobr><span>&nbsp;</span></nobr>
                        </td>
                    </tr>
                </tbody></table>
            </td>
        </tr>
        <tr>
            <td width="96%" valign="TOP" class="nbb tac " style="border-bottom:solid 1px #000000;padding-bottom: 10px">
                <i class="fs-2">(поштовий індекс, область / АР Крим, район, населений пункт, вулиця/провулок, площа тощо, № будинку <b>/</b>корпусу, № квартири <b>/</b>офісу)</i>
            </td>
        </tr>
    </tbody></table>
</div>
<!-- del_block_end -->
<div>
    <br>
    <h1 class="rvps5" style="position:relative;"><span class="rvts8" style="font-size: 14pt; text-align: center;margin-top: -20px;">Розділ А. Загальна інформація</span>
    </h1>
    <div align="right" style="margin-top: -22px; font-size: 10pt"><i>(необхідно позначити ✓)</i></div>
    <div>
        <div align="center" style="margin-top: 0px;">
            <table width="100%" border="1" cellpadding="0" cellspacing="0" style="border-width: 0px; border-collapse: collapse;font-size: 10pt; text-align: center;max-width: 100%; white-space:nowrap;">
                <tbody><tr valign="top">
                    <td width="25%" colspan="2">Тип організації освітньої<br> діяльності</td>
                    <td width="25%" colspan="2">Заклад на кінець<br> звітного року</td>
                    <td width="25%" colspan="2">Заклад засновано на<br>власності</td>
                    <td width="25%" colspan="2">Суб’єкт освітньої<br>діяльності</td>
                </tr>
                <tr valign="bottom">
                    <td class="btl a-left">ясла</td>
                    <td class="btr"><span class="k85-chk" data-k85chk="AtypeKG3"></span></td>
                    <td class="btl a-left">працює</td>
                    <td class="btr"><span class="k85-chk" data-k85chk="AworkKG1"></span></td>
                    <td class="btl a-left">державній</td>
                    <td class="btr"><span class="k85-chk" data-k85chk="ApropKG1"></span></td>
                    <td class="btl a-left">заклад дошкільної освіти</td>
                    <td class="btr" valign="bottom"><span class="k85-chk" data-k85chk="AtypeResp1"></span></td>
                </tr>
                <tr valign="bottom">
                    <td class="bl a-left">дитячий садок</td>
                    <td class="br"><span class="k85-chk" data-k85chk="AtypeKG1"></span></td>
                    <td class="bl a-left" valign="middle">не працює з причин:</td>
                    <td class="br"></td>
                    <td class="bl a-left">комунальній</td>
                    <td class="br"><span class="k85-chk" data-k85chk="ApropKG2"></span></td>
                    <td class="bl a-left">інша юридична особа<br> публічного чи<br> приватного права, що<br> утворила для цього<br> дошкільний підрозділ</td>
                    <td class="br" valign="bottom"><span class="k85-chk" data-k85chk="AtypeResp2"></span></td>
                </tr>
                <tr valign="bottom">
                    <td class="bl a-left">спеціальний дитячий<br> садок</td>
                    <td class="br"><span class="k85-chk" data-k85chk="AtypeKG9"></span></td>
                    <td class="bl a-left">перебуває на<br> капітальному ремонті</td>
                    <td class="br" valign="bottom"><span class="k85-chk" data-k85chk="AworkKG2"></span></td>
                    <td class="bl a-left">приватній</td>
                    <td class="br"><span class="k85-chk" data-k85chk="ApropKG3"></span></td>
                    <td class="bl a-left">фізична особа - <br>підприємець</td>
                    <td class="br" valign="bottom"><span class="k85-chk" data-k85chk="AtypeResp4"></span></td>
                </tr>
                <tr valign="bottom">
                    <td class="bl a-left">мобільний дитячий<br> садок</td>
                    <td class="br"><span class="k85-chk" data-k85chk="AtypeKG10"></span></td>
                    <td class="bl a-left">непридатний для<br> цільового використання</td>
                    <td class="br" valign="bottom"><span class="k85-chk" data-k85chk="AworkKG3"></span></td>
                    <td class="bl a-left">корпоративній</td>
                    <td class="br"><span class="k85-chk" data-k85chk="ApropKG4"></span></td>
                    <td class="bl"></td>
                    <td class="br"></td>
                </tr>
                <tr valign="bottom">
                    <td class="bl a-left">сімейний (родинний)<br> садок</td>
                    <td class="br"><span class="k85-chk" data-k85chk="AtypeKG5"></span></td>
                    <td class="bl a-left">інше</td>
                    <td class="br"><span class="k85-chk" data-k85chk="AworkKG4"></span></td>
                    <td class="bl"></td>
                    <td class="br"></td>
                    <td class="bl"></td>
                    <td class="br"></td>
                </tr>
                <tr valign="bottom">
                    <td class="bl a-left">міні-садок</td>
                    <td class="br"><span class="k85-chk" data-k85chk="AtypeKG6"></span></td>
                    <td class="bl"></td>
                    <td class="br"></td>
                    <td class="bl"></td>
                    <td class="br"></td>
                    <td class="bl"></td>
                    <td class="br"></td>
                </tr>
                <tr valign="bottom">
                    <td class="bl a-left">центр педагогічного<br> партнерства</td>
                    <td class="br"><span class="k85-chk" data-k85chk="AtypeKG7"></span></td>
                    <td class="bl"></td>
                    <td class="br"></td>
                    <td class="bl"></td>
                    <td class="br"></td>
                    <td class="bl"></td>
                    <td class="br"></td>
                </tr>
                <tr valign="bottom">
                    <td class="bbl a-left">центр розвитку<br> дитини</td>
                    <td class="bbr"><span class="k85-chk" data-k85chk="AtypeKG8"></span></td>
                    <td class="bbl"></td>
                    <td class="bbr"></td>
                    <td class="bbl"></td>
                    <td class="bbr"></td>
                    <td class="bbl"></td>
                    <td class="bbr"></td>
                </tr>
            </tbody></table>
        </div>
    </div>
    
    <h1 class="rvps5" style="position:relative;margin-top: 2px;"><span class="rvts8" style="font-size: 14pt; text-align: center;">Розділ I. Кількість дітей у закладі на кінець звітного року</span></h1>
    <div align="right" style="margin-top: -22px;font-size: 10pt; font-style: italic;">(осіб)</div>
    <div align="center" style="margin-top: 0px;">
        <table width="100%" border="1" cellpadding="0" cellspacing="0" style="border-width: 0px; border-collapse: collapse;font-size: 10pt; text-align: center;white-space: nowrap;" class="nopadding">
            <tbody><tr valign="top">
                <td rowspan="3" width="20%"></td>
                <td rowspan="3" valign="middle" width="6%">Код<br>рядка</td>
                <td colspan="6" valign="middle" width="30%">Кількість дітей у закладі</td>
            </tr>
            <tr valign="top">
                <td rowspan="2" valign="middle">Усього<br> (гр. 1 =<br> = сумі<br> гр. 3–6)</td>
                <td rowspan="2" valign="middle">з них<br>дівчата</td>
                <td colspan="4" valign="middle">з графи 1 - за формами здобуття дошкільної освіти</td>
            </tr>
            <tr>
                <td valign="middle">очна<br> (денна)</td>
                <td valign="middle">мережева</td>
                <td valign="middle">дистанційна</td>
                <td valign="middle">педагогічний<br> патронаж</td>
            </tr>
            <tr valign="top">
                <td width="16%">А</td>
                <td>Б</td>
                <td>1</td>
                <td>2</td>
                <td>3</td>
                <td>4</td>
                <td>5</td>
                <td>6</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">Усього (ряд. 1 =
                    <br> = сумі ряд. 2–9 )
                    <br>у тому числі у віці
                </td>
                <td>1</td>
                <td id="r1_1_1" data-k85="CHwork10001">&nbsp;</td>
                <td id="r1_1_2" data-k85="CHwork10002">&nbsp;</td>
                <td id="r1_1_3" data-k85="CHwork100031">&nbsp;</td>
                <td id="r1_1_4" data-k85="CHwork10004">&nbsp;</td>
                <td id="r1_1_5" data-k85="CHwork10005">&nbsp;</td>
                <td id="r1_1_6" data-k85="CHwork10003">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left:25px">до 1 року</td>
                <td>2</td>
                <td id="r1_2_1" data-k85="CHwork11001">&nbsp;</td>
                <td id="r1_2_2" data-k85="CHwork11002">&nbsp;</td>
                <td id="r1_2_3" data-k85="CHwork110031">&nbsp;</td>
                <td id="r1_2_4" data-k85="CHwork11004">&nbsp;</td>
                <td id="r1_2_5" data-k85="CHwork11005">&nbsp;</td>
                <td id="r1_2_6" data-k85="CHwork11003">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left:25px">від 1 до 2 років</td>
                <td>3</td>
                <td id="r1_3_1" data-k85="CHwork12001">&nbsp;</td>
                <td id="r1_3_2" data-k85="CHwork12002">&nbsp;</td>
                <td id="r1_3_3" data-k85="CHwork120031">&nbsp;</td>
                <td id="r1_3_4" data-k85="CHwork12004">&nbsp;</td>
                <td id="r1_3_5" data-k85="CHwork12005">&nbsp;</td>
                <td id="r1_3_6" data-k85="CHwork12003">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left:25px">від 2 до 3 років</td>
                <td>4</td>
                <td id="r1_4_1" data-k85="CHwork13001">&nbsp;</td>
                <td id="r1_4_2" data-k85="CHwork13002">&nbsp;</td>
                <td id="r1_4_3" data-k85="CHwork130031">&nbsp;</td>
                <td id="r1_4_4" data-k85="CHwork13004">&nbsp;</td>
                <td id="r1_4_5" data-k85="CHwork13005">&nbsp;</td>
                <td id="r1_4_6" data-k85="CHwork13003">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left:25px">від 3 до 4 років</td>
                <td>5</td>
                <td id="r1_5_1" data-k85="CHwork14001">&nbsp;</td>
                <td id="r1_5_2" data-k85="CHwork14002">&nbsp;</td>
                <td id="r1_5_3" data-k85="CHwork140031">&nbsp;</td>
                <td id="r1_5_4" data-k85="CHwork14004">&nbsp;</td>
                <td id="r1_5_5" data-k85="CHwork14005">&nbsp;</td>
                <td id="r1_5_6" data-k85="CHwork14003">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left:25px">від 4 до 5 років</td>
                <td>6</td>
                <td id="r1_6_1" data-k85="CHwork601">&nbsp;</td>
                <td id="r1_6_2" data-k85="CHwork602">&nbsp;</td>
                <td id="r1_6_3" data-k85="CHwork603">&nbsp;</td>
                <td id="r1_6_4" data-k85="CHwork604">&nbsp;</td>
                <td id="r1_6_5" data-k85="CHwork605">&nbsp;</td>
                <td id="r1_6_6" data-k85="CHwork606">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left:25px">від 5 до 6 років</td>
                <td>7</td>
                <td id="r1_7_1" data-k85="CHwork701">&nbsp;</td>
                <td id="r1_7_2" data-k85="CHwork702">&nbsp;</td>
                <td id="r1_7_3" data-k85="CHwork703">&nbsp;</td>
                <td id="r1_7_4" data-k85="CHwork704">&nbsp;</td>
                <td id="r1_7_5" data-k85="CHwork705">&nbsp;</td>
                <td id="r1_7_6" data-k85="CHwork706">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left:25px">від 6 до 7 років</td>
                <td>8</td>
                <td id="r1_8_1" data-k85="CHwork801">&nbsp;</td>
                <td id="r1_8_2" data-k85="CHwork802">&nbsp;</td>
                <td id="r1_8_3" data-k85="CHwork803">&nbsp;</td>
                <td id="r1_8_4" data-k85="CHwork804">&nbsp;</td>
                <td id="r1_8_5" data-k85="CHwork805">&nbsp;</td>
                <td id="r1_8_6" data-k85="CHwork806">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left:25px">від 7 до 8 років</td>
                <td>9</td>
                <td id="r1_9_1" data-k85="CHwork901">&nbsp;</td>
                <td id="r1_9_2" data-k85="CHwork902">&nbsp;</td>
                <td id="r1_9_3" data-k85="CHwork903">&nbsp;</td>
                <td id="r1_9_4" data-k85="CHwork904">&nbsp;</td>
                <td id="r1_9_5" data-k85="CHwork905">&nbsp;</td>
                <td id="r1_9_6" data-k85="CHwork906">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">Із рядка 1:</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left:25px">дівчата</td>
                <td>10</td>
                <td id="r1_10_1">x</td>
                <td id="r1_10_2">x</td>
                <td id="r1_10_3" data-k85="CHwork1003">&nbsp;</td>
                <td id="r1_10_4" data-k85="CHwork1004">&nbsp;</td>
                <td id="r1_10_5" data-k85="CHwork1005">&nbsp;</td>
                <td id="r1_10_6" data-k85="CHwork1006">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left:25px">
                    діти-сироти та<br> діти,<br> позбавлені<br> батьківського<br> піклування
                </td>
                <td>11</td>
                <td id="r1_11_1" data-k85="CHwork15001">&nbsp;</td>
                <td id="r1_11_2" data-k85="CHwork15002">&nbsp;</td>
                <td id="r1_11_3" data-k85="CHwork150031">&nbsp;</td>
                <td id="r1_11_4" data-k85="CHwork15004">&nbsp;</td>
                <td id="r1_11_5" data-k85="CHwork15005">&nbsp;</td>
                <td id="r1_11_6" data-k85="CHwork15003">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left:25px">діти з<br> інвалідністю</td>
                <td>12</td>
                <td id="r1_12_1" data-k85="CHwork16101">&nbsp;</td>
                <td id="r1_12_2" data-k85="CHwork16102">&nbsp;</td>
                <td id="r1_12_3" data-k85="CHwork161031">&nbsp;</td>
                <td id="r1_12_4" data-k85="CHwork16104">&nbsp;</td>
                <td id="r1_12_5" data-k85="CHwork16105">&nbsp;</td>
                <td id="r1_12_6" data-k85="CHwork16103">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left:25px">діти з<br> особливими<br> освітніми<br> потребами</td>
                <td>13</td>
                <td id="r1_13_1" data-k85="CHwork16201">&nbsp;</td>
                <td id="r1_13_2" data-k85="CHwork16202">&nbsp;</td>
                <td id="r1_13_3" data-k85="CHwork162031">&nbsp;</td>
                <td id="r1_13_4" data-k85="CHwork16204">&nbsp;</td>
                <td id="r1_13_5" data-k85="CHwork16205">&nbsp;</td>
                <td id="r1_13_6" data-k85="CHwork16203">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left:25px">
                    діти, потерпілі<br> від наслідків<br> Чорнобильської<br> катастрофи
                </td>
                <td>14</td>
                <td id="r1_14_1" data-k85="CHwork17001">&nbsp;</td>
                <td id="r1_14_2" data-k85="CHwork17002">&nbsp;</td>
                <td id="r1_14_3" data-k85="CHwork170031">&nbsp;</td>
                <td id="r1_14_4" data-k85="CHwork17004">&nbsp;</td>
                <td id="r1_14_5" data-k85="CHwork17005">&nbsp;</td>
                <td id="r1_14_6" data-k85="CHwork17003">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left:25px">
                    діти з числа<br> внутрішньо<br> переміщених<br> осіб
                </td>
                <td>15</td>
                <td id="r1_15_1" data-k85="CHwork18001">&nbsp;</td>
                <td id="r1_15_2" data-k85="CHwork18002">&nbsp;</td>
                <td id="r1_15_3" data-k85="CHwork180031">&nbsp;</td>
                <td id="r1_15_4" data-k85="CHwork18004">&nbsp;</td>
                <td id="r1_15_5" data-k85="CHwork18005">&nbsp;</td>
                <td id="r1_15_6" data-k85="CHwork18003">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left:25px">діти учасників<br> бойових дій</td>
                <td>16</td>
                <td id="r1_16_1" data-k85="CHwork19001">&nbsp;</td>
                <td id="r1_16_2" data-k85="CHwork19002">&nbsp;</td>
                <td id="r1_16_3" data-k85="CHwork190031">&nbsp;</td>
                <td id="r1_16_4" data-k85="CHwork19004">&nbsp;</td>
                <td id="r1_16_5" data-k85="CHwork19005">&nbsp;</td>
                <td id="r1_16_6" data-k85="CHwork19003">&nbsp;</td>
            </tr>

        </tbody></table>
    </div>

    <div align="left" style="font-size: 10pt;" class="after-table-fields">
        <p>З рядка 1 — кількість дітей, яким до 1 вересня наступного за звітним року виповниться:</p>
        <p style="padding-left: 35px;">5 років (17) <u><span data-k85="CHwork14101">&nbsp;</span></u>, з них дівчат (18) <u><span data-k85="CHwork14102">&nbsp;</span></u>,</p>
        <p style="padding-left: 35px;">6 років (19) <u><span data-k85="CHwork14201">&nbsp;</span></u>, з них дівчат (20) <u><span data-k85="CHwork14202">&nbsp;</span></u>,</p>
        <p style="padding-left: 35px;">7 років (21) <u><span data-k85="CHwork14301">&nbsp;</span></u>, з них дівчат (22) <u><span data-k85="CHwork14302">&nbsp;</span></u>.</p>
    </div>

    

    <div>
        <h1 class="rvps5"><span class="rvts8" style="font-size: 14pt; text-align: center">Розділ II. Наявність дітей і місць у групах на кінець звітного року</span></h1>
        <div align="center" style="margin-top: 0px;">
            <table width="100%" border="1" cellpadding="0" cellspacing="0" style="border-width: 0px; border-collapse: collapse;font-size: 10pt; text-align: center;white-space: nowrap;" class="nopadding">
                <tbody><tr valign="top">
                    <td rowspan="2" colspan="3" valign="middle" width="32%"></td>
                    <td rowspan="2" valign="middle" width="6%">Код<br>рядка</td>
                    <td colspan="2" valign="middle" width="21%">Кількість дітей, осіб</td>
                    <td colspan="2" valign="middle" width="21%">Кількість груп, од</td>
                    <td colspan="2" valign="middle" width="21%">Кількість місць, од</td>
                </tr>
                <tr valign="top">
                    <td valign="middle" style="text-rotate: 90"><span class="rotate">усього</span></td>
                    <td valign="middle">з них у<br> віці 3<br> роки і<br> старше</td>
                    <td valign="middle" style="text-rotate: 90"><span class="rotate">усього</span></td>
                    <td valign="middle">з них для<br> дітей у віці<br> 3 роки і<br> старше</td>
                    <td valign="middle" style="text-rotate: 90"><span class="rotate">усього</span></td>
                    <td valign="middle">з них для<br> дітей у<br> віці 3 роки<br> і старше</td>
                </tr>
                <tr valign="top">
                    <td colspan="3" width="32%">А</td>
                    <td width="8%">Б</td>
                    <td width="10%">1</td>
                    <td width="10%">2</td>
                    <td width="10%">3</td>
                    <td width="10%">4</td>
                    <td width="10%">5</td>
                    <td width="10%">6</td>
                </tr>
                <tr valign="bottom">
                    <td colspan="3" style="text-align: left;">Усього<br> у тому числі за видами груп:</td>
                    <td>1</td>
                    <td id="r2_1_1" data-k85="GRchild2001">&nbsp;</td>
                    <td id="r2_1_2" data-k85="GRchild2002">&nbsp;</td>
                    <td id="r2_1_3" data-k85="GRchild2003">&nbsp;</td>
                    <td id="r2_1_4" data-k85="GRchild2004">&nbsp;</td>
                    <td id="r2_1_5" data-k85="GRchild2005">&nbsp;</td>
                    <td id="r2_1_6" data-k85="GRchild2006">&nbsp;</td>
                </tr>
                <tr valign="bottom">
                    <td colspan="3" style="text-align: left;">групи загального розвитку</td>
                    <td>2</td>
                    <td id="r2_2_1" data-k85="GRchild21">&nbsp;</td>
                    <td id="r2_2_2" data-k85="GRchild22">&nbsp;</td>
                    <td id="r2_2_3" data-k85="GRchild23">&nbsp;</td>
                    <td id="r2_2_4" data-k85="GRchild24">&nbsp;</td>
                    <td id="r2_2_5" data-k85="GRchild25">&nbsp;</td>
                    <td id="r2_2_6" data-k85="GRchild26">&nbsp;</td>
                </tr>
                <tr valign="bottom">
                    <td colspan="3" style="text-align: left;">спеціальні групи</td>
                    <td>3</td>
                    <td id="r2_3_1" data-k85="GRchild2201">&nbsp;</td>
                    <td id="r2_3_2" data-k85="GRchild2202">&nbsp;</td>
                    <td id="r2_3_3" data-k85="GRchild2203">&nbsp;</td>
                    <td id="r2_3_4" data-k85="GRchild2204">&nbsp;</td>
                    <td id="r2_3_5" data-k85="GRchild2205">&nbsp;</td>
                    <td id="r2_3_6" data-k85="GRchild2206">&nbsp;</td>
                </tr>
                <tr valign="bottom">
                    <td rowspan="8" valign="middle" width="5%" style="text-rotate: 90"><span class="rotate">у тому числі для дітей</span></td>
                    <td style="text-align: left;" colspan="2">з інтелектуальними<br> труднощами</td>
                    <td>4</td>
                    <td id="r2_4_1" data-k85="GRchild2241">&nbsp;</td>
                    <td id="r2_4_2" data-k85="GRchild2242">&nbsp;</td>
                    <td id="r2_4_3" data-k85="GRchild2243">&nbsp;</td>
                    <td id="r2_4_4" data-k85="GRchild2244">&nbsp;</td>
                    <td id="r2_4_5" data-k85="GRchild2245">&nbsp;</td>
                    <td id="r2_4_6" data-k85="GRchild2246">&nbsp;</td>
                </tr>
                <tr valign="bottom">
                    <td style="text-align: left;" colspan="2">з функціональними<br> сенсорними труднощами</td>
                    <td>5</td>
                    <td id="r2_5_1" data-k85="GRchild51">&nbsp;</td>
                    <td id="r2_5_2" data-k85="GRchild52">&nbsp;</td>
                    <td id="r2_5_3" data-k85="GRchild53">&nbsp;</td>
                    <td id="r2_5_4" data-k85="GRchild54">&nbsp;</td>
                    <td id="r2_5_5" data-k85="GRchild55">&nbsp;</td>
                    <td id="r2_5_6" data-k85="GRchild56">&nbsp;</td>
                </tr>
                <tr valign="bottom">
                    <td valign="middle" rowspan="2" colspan="1" width="17%">з них<br> передбачають<br> обмеження</td>
                    <td style="text-align: left;" width="10%">слухової<br> функції</td>
                    <td>6</td>
                    <td id="r2_6_1" data-k85="GRchild2211">&nbsp;</td>
                    <td id="r2_6_2" data-k85="GRchild2212">&nbsp;</td>
                    <td id="r2_6_3" data-k85="GRchild2213">&nbsp;</td>
                    <td id="r2_6_4" data-k85="GRchild2214">&nbsp;</td>
                    <td id="r2_6_5" data-k85="GRchild2215">&nbsp;</td>
                    <td id="r2_6_6" data-k85="GRchild2216">&nbsp;</td>
                </tr>
                <tr valign="bottom">
                    <td style="text-align: left;" width="10%">зорової<br> функції</td>
                    <td>7</td>
                    <td id="r2_7_1" data-k85="GRchild2231">&nbsp;</td>
                    <td id="r2_7_2" data-k85="GRchild2232">&nbsp;</td>
                    <td id="r2_7_3" data-k85="GRchild2233">&nbsp;</td>
                    <td id="r2_7_4" data-k85="GRchild2234">&nbsp;</td>
                    <td id="r2_7_5" data-k85="GRchild2235">&nbsp;</td>
                    <td id="r2_7_6" data-k85="GRchild2236">&nbsp;</td>
                </tr>
                <tr valign="bottom">
                    <td style="text-align: left;" colspan="2">з функціональними<br> фізичними або моторними<br> труднощами</td>
                    <td>8</td>
                    <td id="r2_8_1" data-k85="GRchild2251">&nbsp;</td>
                    <td id="r2_8_2" data-k85="GRchild2252">&nbsp;</td>
                    <td id="r2_8_3" data-k85="GRchild2253">&nbsp;</td>
                    <td id="r2_8_4" data-k85="GRchild2254">&nbsp;</td>
                    <td id="r2_8_5" data-k85="GRchild2255">&nbsp;</td>
                    <td id="r2_8_6" data-k85="GRchild2256">&nbsp;</td>
                </tr>
                <tr valign="bottom">
                    <td style="text-align: left;" colspan="2">з функціональними<br> мовленнєвими труднощами</td>
                    <td>9</td>
                    <td id="r2_9_1" data-k85="GRchild2221">&nbsp;</td>
                    <td id="r2_9_2" data-k85="GRchild2222">&nbsp;</td>
                    <td id="r2_9_3" data-k85="GRchild2223">&nbsp;</td>
                    <td id="r2_9_4" data-k85="GRchild2224">&nbsp;</td>
                    <td id="r2_9_5" data-k85="GRchild2225">&nbsp;</td>
                    <td id="r2_9_6" data-k85="GRchild2226">&nbsp;</td>
                </tr>
                <tr valign="bottom">
                    <td style="text-align: left;" colspan="2">із складними порушеннями<br> розвитку</td>
                    <td>10</td>
                    <td id="r2_10_1" data-k85="GRchild101">&nbsp;</td>
                    <td id="r2_10_2" data-k85="GRchild102">&nbsp;</td>
                    <td id="r2_10_3" data-k85="GRchild103">&nbsp;</td>
                    <td id="r2_10_4" data-k85="GRchild104">&nbsp;</td>
                    <td id="r2_10_5" data-k85="GRchild105">&nbsp;</td>
                    <td id="r2_10_6" data-k85="GRchild106">&nbsp;</td>
                </tr>
                <tr valign="bottom">
                    <td style="text-align: left;" colspan="2">із соціоадаптаційними<br> (соціокультурними)<br> труднощами</td>
                    <td>11</td>
                    <td id="r2_11_1" data-k85="GRchild2261">&nbsp;</td>
                    <td id="r2_11_2" data-k85="GRchild2262">&nbsp;</td>
                    <td id="r2_11_3" data-k85="GRchild2263">&nbsp;</td>
                    <td id="r2_11_4" data-k85="GRchild2264">&nbsp;</td>
                    <td id="r2_11_5" data-k85="GRchild2265">&nbsp;</td>
                    <td id="r2_11_6" data-k85="GRchild2266">&nbsp;</td>
                </tr>
                <tr valign="bottom">
                    <td style="text-align: left;" colspan="3">інклюзивні групи</td>
                    <td>12</td>
                    <td id="r2_12_1" data-k85="GRchild2301">&nbsp;</td>
                    <td id="r2_12_2" data-k85="GRchild2302">&nbsp;</td>
                    <td id="r2_12_3" data-k85="GRchild2303">&nbsp;</td>
                    <td id="r2_12_4" data-k85="GRchild2304">&nbsp;</td>
                    <td id="r2_12_5" data-k85="GRchild2305">&nbsp;</td>
                    <td id="r2_12_6" data-k85="GRchild2306">&nbsp;</td>
                </tr>
                <tr valign="bottom">
                    <td style="text-align: left;" colspan="3">групи короткотривалого<br> перебування</td>
                    <td>13</td>
                    <td id="r2_13_1" data-k85="GRchild2401">&nbsp;</td>
                    <td id="r2_13_2" data-k85="GRchild2402">&nbsp;</td>
                    <td id="r2_13_3" data-k85="GRchild2403">&nbsp;</td>
                    <td id="r2_13_4" data-k85="GRchild2404">&nbsp;</td>
                    <td id="r2_13_5" data-k85="GRchild2405">&nbsp;</td>
                    <td id="r2_13_6" data-k85="GRchild2406">&nbsp;</td>
                </tr>
                <tr valign="bottom">
                    <td style="text-align: left;" colspan="3">групи з цілодобовим<br> перебуванням дітей</td>
                    <td>14</td>
                    <td id="r2_14_1" data-k85="GRchild2501">&nbsp;</td>
                    <td id="r2_14_2" data-k85="GRchild2502">&nbsp;</td>
                    <td id="r2_14_3" data-k85="GRchild2503">&nbsp;</td>
                    <td id="r2_14_4" data-k85="GRchild2504">&nbsp;</td>
                    <td id="r2_14_5" data-k85="GRchild2505">&nbsp;</td>
                    <td id="r2_14_6" data-k85="GRchild2506">&nbsp;</td>
                </tr>
            </tbody></table>
        </div>
    </div>

    <div align="left" style="font-size: 10pt;" class="after-table-fields">
        <p>З рядка 1 – за типом організації освітньої діяльності:</p>
        <p style="padding-left: 35px;">у яслах: кількість груп (15) <u><span data-k85="GRchild2003y">&nbsp;</span></u>, у них дітей&nbsp;(16)&nbsp;<u><span data-k85="GRchild2001y">&nbsp;</span></u>, у тому числі дівчат&nbsp;(17)&nbsp;<u><span data-k85="GRchild2gy">&nbsp;</span></u>;</p>
        <p style="padding-left: 35px;">у дитячому садку: кількість груп (18) <u><span data-k85="GRchild2003k">&nbsp;</span></u>, у них дітей&nbsp;(19)&nbsp;<u><span data-k85="GRchild2001k">&nbsp;</span></u>, у тому числі дівчат&nbsp;(20)&nbsp;<u><span data-k85="GRchild2gk">&nbsp;</span></u>;</p>
        <p style="padding-left: 35px;">у спеціальному дитячому садку: кількість груп (21) <u><span data-k85="GRchild2003s">&nbsp;</span></u>, у них дітей&nbsp;(22)&nbsp;<u><span data-k85="GRchild2001s">&nbsp;</span></u>, у тому числі дівчат&nbsp;(23)&nbsp;<u><span data-k85="GRchild2gs">&nbsp;</span></u>;</p>
        <p style="padding-left: 35px;">у мобільному дитячому садку: кількість груп (24) <u><span data-k85="GRchild2003m">&nbsp;</span></u>, у них дітей&nbsp;(25)&nbsp;<u><span data-k85="GRchild2001m">&nbsp;</span></u>, у тому числі дівчат&nbsp;(26)&nbsp;<u><span data-k85="GRchild2gm">&nbsp;</span></u>;</p>
        <p style="padding-left: 35px;">у сімейному (родинному) садку: кількість груп (27) <u><span data-k85="GRchild2003f">&nbsp;</span></u>, у них дітей&nbsp;(28)&nbsp;<u><span data-k85="GRchild2001f">&nbsp;</span></u>, у тому числі дівчат&nbsp;(29)&nbsp;<u><span>&nbsp;</span></u>;</p>
        <p style="padding-left: 35px;">у міні-садку: кількість груп (30) <u><span data-k85="GRchild2003min">&nbsp;</span></u>, у них дітей&nbsp;(31)&nbsp;<u><span data-k85="GRchild2001min">&nbsp;</span></u>, у тому числі дівчат&nbsp;(32)&nbsp;<u><span data-k85="GRchild2gmin">&nbsp;</span></u>;</p>
        <p style="padding-left: 35px;">у центрі педагогічного партнерства: кількість груп (33) <u><span data-k85="GRchild2003p">&nbsp;</span></u>, у них дітей&nbsp;(34)&nbsp;<u><span data-k85="GRchild2001p">&nbsp;</span></u>, у тому числі дівчат&nbsp;(35)&nbsp;<u><span data-k85="GRchild2gp">&nbsp;</span></u>;</p>
        <p style="padding-left: 35px;">у центрі розвитку дитини: кількість груп (36) <u><span data-k85="GRchild2003ch">&nbsp;</span></u>, у них дітей&nbsp;(37)&nbsp;<u><span data-k85="GRchild2001ch">&nbsp;</span></u>, у тому числі дівчат&nbsp;(38)&nbsp;<u><span data-k85="GRchild2gch">&nbsp;</span></u>.</p>
    </div>

    

    <h1 class="rvps5" style="position:relative;"><span class="rvts8" style="font-size: 14pt; text-align: center;">Розділ IІІ. Кількість дітей з особливими освітніми потребами (ООП) на кінець звітного року</span></h1>
    <div align="right" style="font-size: 10pt; font-style: italic;">(осіб)</div>

    <div align="center" style="margin-top: 0px; overflow: hidden;">
        <table align="left" width="100%" border="1" cellpadding="0" cellspacing="0" style="border-width: 0px; border-collapse: collapse;font-size: 10pt; text-align: center;white-space: nowrap;" class="nopadding report-table">
            <tbody><tr valign="top" style="height: 34px;">
                <td colspan="3" rowspan="3" valign="middle">Назва показника</td>
                <td rowspan="3" valign="middle" style="text-rotate: 90"><span class="rotate">Код рядка</span></td>
                <td rowspan="3" valign="middle">
                    <table class="nested-table">
                        <tbody><tr style="text-rotate: 90">
                            <td><span class="rotate">Усього дітей</span></td>
                            <td><span class="rotate">з ООП, осіб</span></td>
                        </tr>
                    </tbody></table>
                </td>
                <td colspan="5" valign="middle">З них:</td>
            </tr>
            <tr valign="top">
                <td colspan="2" valign="middle">за віком</td>
                <td rowspan="2" valign="middle">в групах<br> загального<br> розвитку</td>
                <td rowspan="2" valign="middle">в інклюзивних<br> групах</td>
                <td rowspan="2" valign="middle">в<br> спеціальних<br> групах</td>
            </tr>
            <tr valign="top">
                <td valign="middle">до 3<br> років</td>
                <td valign="middle">старше 3<br> років</td>
            </tr>
            <tr valign="top">
                <td width="32%" colspan="3" valign="middle">А</td>
                <td width="6%" valign="middle">Б</td>
                <td width="10%" valign="middle">1</td>
                <td width="9%" valign="middle">2</td>
                <td width="9%" valign="middle">3</td>
                <td width="10%" valign="middle">4</td>
                <td width="12%" valign="middle">5</td>
                <td width="12%" valign="middle">6</td>
            </tr>
            <tr valign="bottom">
                <td colspan="3" style="text-align: left;">Усього<br>
                    у тому числі за категоріями<br> (типами) ООП (труднощів)<br>
                    (ряд.1 = сумі ряд. 2, 8, 39, 45, 51)
                </td>
                <td>1</td>
                <td id="r3_1_1" data-k85="OOP11">&nbsp;</td>
                <td id="r3_1_2" data-k85="OOP12">&nbsp;</td>
                <td id="r3_1_3" data-k85="OOP13">&nbsp;</td>
                <td id="r3_1_4" data-k85="OOP14">&nbsp;</td>
                <td id="r3_1_5" data-k85="OOP15">&nbsp;</td>
                <td id="r3_1_6" data-k85="OOP16">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="3" style="text-align: left;">інтелектуальні труднощі<br>
                    (ряд. 2 =  сумі ряд. 3–7 )
                </td>
                <td>2</td>
                <td id="r3_2_1" data-k85="OOP21">&nbsp;</td>
                <td id="r3_2_2" data-k85="OOP22">&nbsp;</td>
                <td id="r3_2_3" data-k85="OOP23">&nbsp;</td>
                <td id="r3_2_4" data-k85="OOP24">&nbsp;</td>
                <td id="r3_2_5" data-k85="OOP25">&nbsp;</td>
                <td id="r3_2_6" data-k85="OOP26">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td width="5%" rowspan="5" valign="middle" style="text-rotate: 90">
                    <span class="rotate">з них</span>
                </td>
                <td colspan="2" style="text-align: left;">1 рівень підтримки</td>
                <td>3</td>
                <td id="r3_3_1" data-k85="OOP31">&nbsp;</td>
                <td id="r3_3_2" data-k85="OOP32">&nbsp;</td>
                <td id="r3_3_3" data-k85="OOP33">&nbsp;</td>
                <td id="r3_3_4" data-k85="OOP34">&nbsp;</td>
                <td id="r3_3_5" data-k85="OOP35">&nbsp;</td>
                <td id="r3_3_6" data-k85="OOP36">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">2 рівень підтримки</td>
                <td>4</td>
                <td id="r3_4_1" data-k85="OOP41">&nbsp;</td>
                <td id="r3_4_2" data-k85="OOP42">&nbsp;</td>
                <td id="r3_4_3" data-k85="OOP43">&nbsp;</td>
                <td id="r3_4_4" data-k85="OOP44">&nbsp;</td>
                <td id="r3_4_5" data-k85="OOP45">&nbsp;</td>
                <td id="r3_4_6" data-k85="OOP46">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">3 рівень підтримки</td>
                <td>5</td>
                <td id="r3_5_1" data-k85="OOP51">&nbsp;</td>
                <td id="r3_5_2" data-k85="OOP52">&nbsp;</td>
                <td id="r3_5_3" data-k85="OOP53">&nbsp;</td>
                <td id="r3_5_4" data-k85="OOP54">&nbsp;</td>
                <td id="r3_5_5" data-k85="OOP55">&nbsp;</td>
                <td id="r3_5_6" data-k85="OOP56">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">4 рівень підтримки</td>
                <td>6</td>
                <td id="r3_6_1" data-k85="OOP61">&nbsp;</td>
                <td id="r3_6_2" data-k85="OOP62">&nbsp;</td>
                <td id="r3_6_3" data-k85="OOP63">&nbsp;</td>
                <td id="r3_6_4" data-k85="OOP64">&nbsp;</td>
                <td id="r3_6_5" data-k85="OOP65">&nbsp;</td>
                <td id="r3_6_6" data-k85="OOP66">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">5 рівень підтримки</td>
                <td>7</td>
                <td id="r3_7_1" data-k85="OOP71">&nbsp;</td>
                <td id="r3_7_2" data-k85="OOP72">&nbsp;</td>
                <td id="r3_7_3" data-k85="OOP73">&nbsp;</td>
                <td id="r3_7_4" data-k85="OOP74">&nbsp;</td>
                <td id="r3_7_5" data-k85="OOP75">&nbsp;</td>
                <td id="r3_7_6" data-k85="OOP76">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="3" style="text-align: left;">функціональні труднощі</td>
                <td>8</td>
                <td id="r3_8_1" data-k85="OOP81">&nbsp;</td>
                <td id="r3_8_2" data-k85="OOP82">&nbsp;</td>
                <td id="r3_8_3" data-k85="OOP83">&nbsp;</td>
                <td id="r3_8_4" data-k85="OOP84">&nbsp;</td>
                <td id="r3_8_5" data-k85="OOP85">&nbsp;</td>
                <td id="r3_8_6" data-k85="OOP86">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td width="5%" rowspan="25" valign="middle" style="text-rotate: 90">
                    <span class="rotate">у тому числі</span>
                </td>
                <td colspan="2" style="text-align: left;">Сенсорні<br>
                    (ряд. 9 =  сумі ряд. 10–14 )<br>
                    (ряд. 9  ≥ сумі ряд. 15, 21, 27, 33)
                </td>
                <td>9</td>
                <td id="r3_9_1" data-k85="OOP91">&nbsp;</td>
                <td id="r3_9_2" data-k85="OOP92">&nbsp;</td>
                <td id="r3_9_3" data-k85="OOP93">&nbsp;</td>
                <td id="r3_9_4" data-k85="OOP94">&nbsp;</td>
                <td id="r3_9_5" data-k85="OOP95">&nbsp;</td>
                <td id="r3_9_6" data-k85="OOP96">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td width="5%" rowspan="5" valign="middle" style="text-rotate: 90">
                    <span class="rotate">з них</span>
                </td>
                <td style="text-align: left;">1 рівень підтримки</td>
                <td>10</td>
                <td id="r3_10_1" data-k85="OOP101">&nbsp;</td>
                <td id="r3_10_2" data-k85="OOP102">&nbsp;</td>
                <td id="r3_10_3" data-k85="OOP103">&nbsp;</td>
                <td id="r3_10_4" data-k85="OOP104">&nbsp;</td>
                <td id="r3_10_5" data-k85="OOP105">&nbsp;</td>
                <td id="r3_10_6" data-k85="OOP106">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">2 рівень підтримки</td>
                <td>11</td>
                <td id="r3_11_1" data-k85="OOP111">&nbsp;</td>
                <td id="r3_11_2" data-k85="OOP112">&nbsp;</td>
                <td id="r3_11_3" data-k85="OOP113">&nbsp;</td>
                <td id="r3_11_4" data-k85="OOP114">&nbsp;</td>
                <td id="r3_11_5" data-k85="OOP115">&nbsp;</td>
                <td id="r3_11_6" data-k85="OOP116">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">3 рівень підтримки</td>
                <td>12</td>
                <td id="r3_12_1" data-k85="OOP121">&nbsp;</td>
                <td id="r3_12_2" data-k85="OOP122">&nbsp;</td>
                <td id="r3_12_3" data-k85="OOP123">&nbsp;</td>
                <td id="r3_12_4" data-k85="OOP124">&nbsp;</td>
                <td id="r3_12_5" data-k85="OOP125">&nbsp;</td>
                <td id="r3_12_6" data-k85="OOP126">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">4 рівень підтримки</td>
                <td>13</td>
                <td id="r3_13_1" data-k85="OOP131">&nbsp;</td>
                <td id="r3_13_2" data-k85="OOP132">&nbsp;</td>
                <td id="r3_13_3" data-k85="OOP133">&nbsp;</td>
                <td id="r3_13_4" data-k85="OOP134">&nbsp;</td>
                <td id="r3_13_5" data-k85="OOP135">&nbsp;</td>
                <td id="r3_13_6" data-k85="OOP136">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">5 рівень підтримки</td>
                <td>14</td>
                <td id="r3_14_1" data-k85="OOP141">&nbsp;</td>
                <td id="r3_14_2" data-k85="OOP142">&nbsp;</td>
                <td id="r3_14_3" data-k85="OOP143">&nbsp;</td>
                <td id="r3_14_4" data-k85="OOP144">&nbsp;</td>
                <td id="r3_14_5" data-k85="OOP145">&nbsp;</td>
                <td id="r3_14_6" data-k85="OOP146">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">з рядка 9 передбачають<br> обмеження: </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">слухової функції<br>
                    (ряд. 15 =  сумі ряд. 16–20 )
                </td>
                <td>15</td>
                <td id="r3_15_1" data-k85="OOP151">&nbsp;</td>
                <td id="r3_15_2" data-k85="OOP152">&nbsp;</td>
                <td id="r3_15_3" data-k85="OOP153">&nbsp;</td>
                <td id="r3_15_4" data-k85="OOP154">&nbsp;</td>
                <td id="r3_15_5" data-k85="OOP155">&nbsp;</td>
                <td id="r3_15_6" data-k85="OOP156">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td width="5%" rowspan="5" valign="middle" style="text-rotate: 90">
                    <span class="rotate">з них</span>
                </td>
                <td style="text-align: left;">1 рівень підтримки</td>
                <td>16</td>
                <td id="r3_16_1" data-k85="OOP161">&nbsp;</td>
                <td id="r3_16_2" data-k85="OOP162">&nbsp;</td>
                <td id="r3_16_3" data-k85="OOP163">&nbsp;</td>
                <td id="r3_16_4" data-k85="OOP164">&nbsp;</td>
                <td id="r3_16_5" data-k85="OOP165">&nbsp;</td>
                <td id="r3_16_6" data-k85="OOP166">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">2 рівень підтримки</td>
                <td>17</td>
                <td id="r3_17_1" data-k85="OOP171">&nbsp;</td>
                <td id="r3_17_2" data-k85="OOP172">&nbsp;</td>
                <td id="r3_17_3" data-k85="OOP173">&nbsp;</td>
                <td id="r3_17_4" data-k85="OOP174">&nbsp;</td>
                <td id="r3_17_5" data-k85="OOP175">&nbsp;</td>
                <td id="r3_17_6" data-k85="OOP176">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">3 рівень підтримки</td>
                <td>18</td>
                <td id="r3_18_1" data-k85="OOP181">&nbsp;</td>
                <td id="r3_18_2" data-k85="OOP182">&nbsp;</td>
                <td id="r3_18_3" data-k85="OOP183">&nbsp;</td>
                <td id="r3_18_4" data-k85="OOP184">&nbsp;</td>
                <td id="r3_18_5" data-k85="OOP185">&nbsp;</td>
                <td id="r3_18_6" data-k85="OOP186">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">4 рівень підтримки</td>
                <td>19</td>
                <td id="r3_19_1" data-k85="OOP191">&nbsp;</td>
                <td id="r3_19_2" data-k85="OOP192">&nbsp;</td>
                <td id="r3_19_3" data-k85="OOP193">&nbsp;</td>
                <td id="r3_19_4" data-k85="OOP194">&nbsp;</td>
                <td id="r3_19_5" data-k85="OOP195">&nbsp;</td>
                <td id="r3_19_6" data-k85="OOP196">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">5 рівень підтримки</td>
                <td>20</td>
                <td id="r3_20_1" data-k85="OOP201">&nbsp;</td>
                <td id="r3_20_2" data-k85="OOP202">&nbsp;</td>
                <td id="r3_20_3" data-k85="OOP203">&nbsp;</td>
                <td id="r3_20_4" data-k85="OOP204">&nbsp;</td>
                <td id="r3_20_5" data-k85="OOP205">&nbsp;</td>
                <td id="r3_20_6" data-k85="OOP206">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">зорової функції<br>
                    (ряд. 21 =  сумі ряд. 22–26 )
                </td>
                <td>21</td>
                <td id="r3_21_1" data-k85="OOP211">&nbsp;</td>
                <td id="r3_21_2" data-k85="OOP212">&nbsp;</td>
                <td id="r3_21_3" data-k85="OOP213">&nbsp;</td>
                <td id="r3_21_4" data-k85="OOP214">&nbsp;</td>
                <td id="r3_21_5" data-k85="OOP215">&nbsp;</td>
                <td id="r3_21_6" data-k85="OOP216">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td width="5%" rowspan="5" valign="middle" style="text-rotate: 90">
                    <span class="rotate">з них</span>
                </td>
                <td style="text-align: left;">1 рівень підтримки</td>
                <td>22</td>
                <td id="r3_22_1" data-k85="OOP221">&nbsp;</td>
                <td id="r3_22_2" data-k85="OOP222">&nbsp;</td>
                <td id="r3_22_3" data-k85="OOP223">&nbsp;</td>
                <td id="r3_22_4" data-k85="OOP224">&nbsp;</td>
                <td id="r3_22_5" data-k85="OOP225">&nbsp;</td>
                <td id="r3_22_6" data-k85="OOP226">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">2 рівень підтримки</td>
                <td>23</td>
                <td id="r3_23_1" data-k85="OOP231">&nbsp;</td>
                <td id="r3_23_2" data-k85="OOP232">&nbsp;</td>
                <td id="r3_23_3" data-k85="OOP233">&nbsp;</td>
                <td id="r3_23_4" data-k85="OOP234">&nbsp;</td>
                <td id="r3_23_5" data-k85="OOP235">&nbsp;</td>
                <td id="r3_23_6" data-k85="OOP236">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">3 рівень підтримки</td>
                <td>24</td>
                <td id="r3_24_1" data-k85="OOP241">&nbsp;</td>
                <td id="r3_24_2" data-k85="OOP242">&nbsp;</td>
                <td id="r3_24_3" data-k85="OOP243">&nbsp;</td>
                <td id="r3_24_4" data-k85="OOP244">&nbsp;</td>
                <td id="r3_24_5" data-k85="OOP245">&nbsp;</td>
                <td id="r3_24_6" data-k85="OOP246">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">4 рівень підтримки</td>
                <td>25</td>
                <td id="r3_25_1" data-k85="OOP251">&nbsp;</td>
                <td id="r3_25_2" data-k85="OOP252">&nbsp;</td>
                <td id="r3_25_3" data-k85="OOP253">&nbsp;</td>
                <td id="r3_25_4" data-k85="OOP254">&nbsp;</td>
                <td id="r3_25_5" data-k85="OOP255">&nbsp;</td>
                <td id="r3_25_6" data-k85="OOP256">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">5 рівень підтримки</td>
                <td>26</td>
                <td id="r3_26_1" data-k85="OOP261">&nbsp;</td>
                <td id="r3_26_2" data-k85="OOP262">&nbsp;</td>
                <td id="r3_26_3" data-k85="OOP263">&nbsp;</td>
                <td id="r3_26_4" data-k85="OOP264">&nbsp;</td>
                <td id="r3_26_5" data-k85="OOP265">&nbsp;</td>
                <td id="r3_26_6" data-k85="OOP266">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">моторні<br>
                    (ряд. 27 =  сумі ряд. 28–32 )
                </td>
                <td>27</td>
                <td id="r3_27_1" data-k85="OOP271">&nbsp;</td>
                <td id="r3_27_2" data-k85="OOP272">&nbsp;</td>
                <td id="r3_27_3" data-k85="OOP273">&nbsp;</td>
                <td id="r3_27_4" data-k85="OOP274">&nbsp;</td>
                <td id="r3_27_5" data-k85="OOP275">&nbsp;</td>
                <td id="r3_27_6" data-k85="OOP276">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td width="5%" rowspan="5" valign="middle" style="text-rotate: 90">
                    <span class="rotate">з них</span>
                </td>
                <td style="text-align: left;">1 рівень підтримки</td>
                <td>28</td>
                <td id="r3_28_1" data-k85="OOP281">&nbsp;</td>
                <td id="r3_28_2" data-k85="OOP282">&nbsp;</td>
                <td id="r3_28_3" data-k85="OOP283">&nbsp;</td>
                <td id="r3_28_4" data-k85="OOP284">&nbsp;</td>
                <td id="r3_28_5" data-k85="OOP285">&nbsp;</td>
                <td id="r3_28_6" data-k85="OOP286">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">2 рівень підтримки</td>
                <td>29</td>
                <td id="r3_29_1" data-k85="OOP291">&nbsp;</td>
                <td id="r3_29_2" data-k85="OOP292">&nbsp;</td>
                <td id="r3_29_3" data-k85="OOP293">&nbsp;</td>
                <td id="r3_29_4" data-k85="OOP294">&nbsp;</td>
                <td id="r3_29_5" data-k85="OOP295">&nbsp;</td>
                <td id="r3_29_6" data-k85="OOP296">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">3 рівень підтримки</td>
                <td>30</td>
                <td id="r3_30_1" data-k85="OOP301">&nbsp;</td>
                <td id="r3_30_2" data-k85="OOP302">&nbsp;</td>
                <td id="r3_30_3" data-k85="OOP303">&nbsp;</td>
                <td id="r3_30_4" data-k85="OOP304">&nbsp;</td>
                <td id="r3_30_5" data-k85="OOP305">&nbsp;</td>
                <td id="r3_30_6" data-k85="OOP306">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">4 рівень підтримки</td>
                <td>31</td>
                <td id="r3_31_1" data-k85="OOP311">&nbsp;</td>
                <td id="r3_31_2" data-k85="OOP312">&nbsp;</td>
                <td id="r3_31_3" data-k85="OOP313">&nbsp;</td>
                <td id="r3_31_4" data-k85="OOP314">&nbsp;</td>
                <td id="r3_31_5" data-k85="OOP315">&nbsp;</td>
                <td id="r3_31_6" data-k85="OOP316">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">5 рівень підтримки</td>
                <td>32</td>
                <td id="r3_32_1" data-k85="OOP321">&nbsp;</td>
                <td id="r3_32_2" data-k85="OOP322">&nbsp;</td>
                <td id="r3_32_3" data-k85="OOP323">&nbsp;</td>
                <td id="r3_32_4" data-k85="OOP324">&nbsp;</td>
                <td id="r3_32_5" data-k85="OOP325">&nbsp;</td>
                <td id="r3_32_6" data-k85="OOP326">&nbsp;</td>
            </tr>
    

    

    
            <tr valign="bottom">
                <td width="5%" rowspan="6"></td>
                <td colspan="2" style="text-align: left;">мовленнєві<br>
                    (ряд. 33 =  сумі ряд. 34–38 )
                </td>
                <td>33</td>
                <td id="r3_33_1" data-k85="OOP331">&nbsp;</td>
                <td id="r3_33_2" data-k85="OOP332">&nbsp;</td>
                <td id="r3_33_3" data-k85="OOP333">&nbsp;</td>
                <td id="r3_33_4" data-k85="OOP334">&nbsp;</td>
                <td id="r3_33_5" data-k85="OOP335">&nbsp;</td>
                <td id="r3_33_6" data-k85="OOP336">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td width="5%" rowspan="5" valign="middle" style="text-rotate: 90">
                    <span class="rotate">з них</span>
                </td>
                <td style="text-align: left;">1 рівень підтримки</td>
                <td>34</td>
                <td id="r3_34_1" data-k85="OOP341">&nbsp;</td>
                <td id="r3_34_2" data-k85="OOP342">&nbsp;</td>
                <td id="r3_34_3" data-k85="OOP343">&nbsp;</td>
                <td id="r3_34_4" data-k85="OOP344">&nbsp;</td>
                <td id="r3_34_5" data-k85="OOP345">&nbsp;</td>
                <td id="r3_34_6" data-k85="OOP346">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">2 рівень підтримки</td>
                <td>35</td>
                <td id="r3_35_1" data-k85="OOP351">&nbsp;</td>
                <td id="r3_35_2" data-k85="OOP352">&nbsp;</td>
                <td id="r3_35_3" data-k85="OOP353">&nbsp;</td>
                <td id="r3_35_4" data-k85="OOP354">&nbsp;</td>
                <td id="r3_35_5" data-k85="OOP355">&nbsp;</td>
                <td id="r3_35_6" data-k85="OOP356">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">3 рівень підтримки</td>
                <td>36</td>
                <td id="r3_36_1" data-k85="OOP361">&nbsp;</td>
                <td id="r3_36_2" data-k85="OOP362">&nbsp;</td>
                <td id="r3_36_3" data-k85="OOP363">&nbsp;</td>
                <td id="r3_36_4" data-k85="OOP364">&nbsp;</td>
                <td id="r3_36_5" data-k85="OOP365">&nbsp;</td>
                <td id="r3_36_6" data-k85="OOP366">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">4 рівень підтримки</td>
                <td>37</td>
                <td id="r3_37_1" data-k85="OOP371">&nbsp;</td>
                <td id="r3_37_2" data-k85="OOP372">&nbsp;</td>
                <td id="r3_37_3" data-k85="OOP373">&nbsp;</td>
                <td id="r3_37_4" data-k85="OOP374">&nbsp;</td>
                <td id="r3_37_5" data-k85="OOP375">&nbsp;</td>
                <td id="r3_37_6" data-k85="OOP376">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">5 рівень підтримки</td>
                <td>38</td>
                <td id="r3_38_1" data-k85="OOP381">&nbsp;</td>
                <td id="r3_38_2" data-k85="OOP382">&nbsp;</td>
                <td id="r3_38_3" data-k85="OOP383">&nbsp;</td>
                <td id="r3_38_4" data-k85="OOP384">&nbsp;</td>
                <td id="r3_38_5" data-k85="OOP385">&nbsp;</td>
                <td id="r3_38_6" data-k85="OOP386">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="3" style="text-align: left;">фізичні труднощі<br>
                    (ряд. 39 =  сумі ряд. 40–44 )
                </td>
                <td>39</td>
                <td id="r3_39_1" data-k85="OOP391">&nbsp;</td>
                <td id="r3_39_2" data-k85="OOP392">&nbsp;</td>
                <td id="r3_39_3" data-k85="OOP393">&nbsp;</td>
                <td id="r3_39_4" data-k85="OOP394">&nbsp;</td>
                <td id="r3_39_5" data-k85="OOP395">&nbsp;</td>
                <td id="r3_39_6" data-k85="OOP396">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td width="5%" rowspan="5" valign="middle" style="text-rotate: 90">
                    <span class="rotate">з них</span>
                </td>
                <td colspan="2" style="text-align: left;">1 рівень підтримки</td>
                <td>40</td>
                <td id="r3_40_1" data-k85="OOP401">&nbsp;</td>
                <td id="r3_40_2" data-k85="OOP402">&nbsp;</td>
                <td id="r3_40_3" data-k85="OOP403">&nbsp;</td>
                <td id="r3_40_4" data-k85="OOP404">&nbsp;</td>
                <td id="r3_40_5" data-k85="OOP405">&nbsp;</td>
                <td id="r3_40_6" data-k85="OOP406">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">2 рівень підтримки</td>
                <td>41</td>
                <td id="r3_41_1" data-k85="OOP411">&nbsp;</td>
                <td id="r3_41_2" data-k85="OOP412">&nbsp;</td>
                <td id="r3_41_3" data-k85="OOP413">&nbsp;</td>
                <td id="r3_41_4" data-k85="OOP414">&nbsp;</td>
                <td id="r3_41_5" data-k85="OOP415">&nbsp;</td>
                <td id="r3_41_6" data-k85="OOP416">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">3 рівень підтримки</td>
                <td>42</td>
                <td id="r3_42_1" data-k85="OOP421">&nbsp;</td>
                <td id="r3_42_2" data-k85="OOP422">&nbsp;</td>
                <td id="r3_42_3" data-k85="OOP423">&nbsp;</td>
                <td id="r3_42_4" data-k85="OOP424">&nbsp;</td>
                <td id="r3_42_5" data-k85="OOP425">&nbsp;</td>
                <td id="r3_42_6" data-k85="OOP426">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">4 рівень підтримки</td>
                <td>43</td>
                <td id="r3_43_1" data-k85="OOP431">&nbsp;</td>
                <td id="r3_43_2" data-k85="OOP432">&nbsp;</td>
                <td id="r3_43_3" data-k85="OOP433">&nbsp;</td>
                <td id="r3_43_4" data-k85="OOP434">&nbsp;</td>
                <td id="r3_43_5" data-k85="OOP435">&nbsp;</td>
                <td id="r3_43_6" data-k85="OOP436">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">5 рівень підтримки</td>
                <td>44</td>
                <td id="r3_44_1" data-k85="OOP441">&nbsp;</td>
                <td id="r3_44_2" data-k85="OOP442">&nbsp;</td>
                <td id="r3_44_3" data-k85="OOP443">&nbsp;</td>
                <td id="r3_44_4" data-k85="OOP444">&nbsp;</td>
                <td id="r3_44_5" data-k85="OOP445">&nbsp;</td>
                <td id="r3_44_6" data-k85="OOP446">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="3" style="text-align: left;">навчальні труднощі<br>
                    (ряд. 45 =  сумі ряд. 46–50 )
                </td>
                <td>45</td>
                <td id="r3_45_1" data-k85="OOP451">&nbsp;</td>
                <td id="r3_45_2" data-k85="OOP452">&nbsp;</td>
                <td id="r3_45_3" data-k85="OOP453">&nbsp;</td>
                <td id="r3_45_4" data-k85="OOP454">&nbsp;</td>
                <td id="r3_45_5" data-k85="OOP455">&nbsp;</td>
                <td id="r3_45_6" data-k85="OOP456">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td width="5%" rowspan="5" valign="middle" style="text-rotate: 90">
                    <span class="rotate">з них</span>
                </td>
                <td colspan="2" style="text-align: left;">1 рівень підтримки</td>
                <td>46</td>
                <td id="r3_46_1" data-k85="OOP461">&nbsp;</td>
                <td id="r3_46_2" data-k85="OOP462">&nbsp;</td>
                <td id="r3_46_3" data-k85="OOP463">&nbsp;</td>
                <td id="r3_46_4" data-k85="OOP464">&nbsp;</td>
                <td id="r3_46_5" data-k85="OOP465">&nbsp;</td>
                <td id="r3_46_6" data-k85="OOP466">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">2 рівень підтримки</td>
                <td>47</td>
                <td id="r3_47_1" data-k85="OOP471">&nbsp;</td>
                <td id="r3_47_2" data-k85="OOP472">&nbsp;</td>
                <td id="r3_47_3" data-k85="OOP473">&nbsp;</td>
                <td id="r3_47_4" data-k85="OOP474">&nbsp;</td>
                <td id="r3_47_5" data-k85="OOP475">&nbsp;</td>
                <td id="r3_47_6" data-k85="OOP476">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">3 рівень підтримки</td>
                <td>48</td>
                <td id="r3_48_1" data-k85="OOP481">&nbsp;</td>
                <td id="r3_48_2" data-k85="OOP482">&nbsp;</td>
                <td id="r3_48_3" data-k85="OOP483">&nbsp;</td>
                <td id="r3_48_4" data-k85="OOP484">&nbsp;</td>
                <td id="r3_48_5" data-k85="OOP485">&nbsp;</td>
                <td id="r3_48_6" data-k85="OOP486">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">4 рівень підтримки</td>
                <td>49</td>
                <td id="r3_49_1" data-k85="OOP491">&nbsp;</td>
                <td id="r3_49_2" data-k85="OOP492">&nbsp;</td>
                <td id="r3_49_3" data-k85="OOP493">&nbsp;</td>
                <td id="r3_49_4" data-k85="OOP494">&nbsp;</td>
                <td id="r3_49_5" data-k85="OOP495">&nbsp;</td>
                <td id="r3_49_6" data-k85="OOP496">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">5 рівень підтримки</td>
                <td>50</td>
                <td id="r3_50_1" data-k85="OOP501">&nbsp;</td>
                <td id="r3_50_2" data-k85="OOP502">&nbsp;</td>
                <td id="r3_50_3" data-k85="OOP503">&nbsp;</td>
                <td id="r3_50_4" data-k85="OOP504">&nbsp;</td>
                <td id="r3_50_5" data-k85="OOP505">&nbsp;</td>
                <td id="r3_50_6" data-k85="OOP506">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="3" style="text-align: left;">соціоадаптаційні<br>
                    (соціокультурні) труднощі<br>
                    (ряд. 51 =  сумі ряд. 52–56 )
                </td>
                <td>51</td>
                <td id="r3_51_1" data-k85="OOP511">&nbsp;</td>
                <td id="r3_51_2" data-k85="OOP512">&nbsp;</td>
                <td id="r3_51_3" data-k85="OOP513">&nbsp;</td>
                <td id="r3_51_4" data-k85="OOP514">&nbsp;</td>
                <td id="r3_51_5" data-k85="OOP515">&nbsp;</td>
                <td id="r3_51_6" data-k85="OOP516">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td width="5%" rowspan="5" valign="middle" style="text-rotate: 90">
                    <span class="rotate">з них</span>
                </td>
                <td colspan="2" style="text-align: left;">1 рівень підтримки</td>
                <td>52</td>
                <td id="r3_52_1" data-k85="OOP521">&nbsp;</td>
                <td id="r3_52_2" data-k85="OOP522">&nbsp;</td>
                <td id="r3_52_3" data-k85="OOP523">&nbsp;</td>
                <td id="r3_52_4" data-k85="OOP524">&nbsp;</td>
                <td id="r3_52_5" data-k85="OOP525">&nbsp;</td>
                <td id="r3_52_6" data-k85="OOP526">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">2 рівень підтримки</td>
                <td>53</td>
                <td id="r3_53_1" data-k85="OOP531">&nbsp;</td>
                <td id="r3_53_2" data-k85="OOP532">&nbsp;</td>
                <td id="r3_53_3" data-k85="OOP533">&nbsp;</td>
                <td id="r3_53_4" data-k85="OOP534">&nbsp;</td>
                <td id="r3_53_5" data-k85="OOP535">&nbsp;</td>
                <td id="r3_53_6" data-k85="OOP536">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">3 рівень підтримки</td>
                <td>54</td>
                <td id="r3_54_1" data-k85="OOP541">&nbsp;</td>
                <td id="r3_54_2" data-k85="OOP542">&nbsp;</td>
                <td id="r3_54_3" data-k85="OOP543">&nbsp;</td>
                <td id="r3_54_4" data-k85="OOP544">&nbsp;</td>
                <td id="r3_54_5" data-k85="OOP545">&nbsp;</td>
                <td id="r3_54_6" data-k85="OOP546">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">4 рівень підтримки</td>
                <td>55</td>
                <td id="r3_55_1" data-k85="OOP551">&nbsp;</td>
                <td id="r3_55_2" data-k85="OOP552">&nbsp;</td>
                <td id="r3_55_3" data-k85="OOP553">&nbsp;</td>
                <td id="r3_55_4" data-k85="OOP554">&nbsp;</td>
                <td id="r3_55_5" data-k85="OOP555">&nbsp;</td>
                <td id="r3_55_6" data-k85="OOP556">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">5 рівень підтримки</td>
                <td>56</td>
                <td id="r3_56_1" data-k85="OOP561">&nbsp;</td>
                <td id="r3_56_2" data-k85="OOP562">&nbsp;</td>
                <td id="r3_56_3" data-k85="OOP563">&nbsp;</td>
                <td id="r3_56_4" data-k85="OOP564">&nbsp;</td>
                <td id="r3_56_5" data-k85="OOP565">&nbsp;</td>
                <td id="r3_56_6" data-k85="OOP566">&nbsp;</td>
            </tr>
        </tbody></table>
    </div>

    

    <h1 class="rvps5" style="position:relative;"><span class="rvts8" style="font-size: 14pt; text-align: center;">
        Розділ ІV. Кількість працівників закладу на кінець звітного року</span>
    </h1>

    <div align="center" style="margin-top: -8px;">
        <table width="100%" border="1" cellpadding="0" cellspacing="0" style="border-width: 0px; border-collapse: collapse;font-size: 10pt; text-align: center;white-space: nowrap;" class="nopadding report-table">
            <tbody><tr valign="top">
                <td colspan="2" rowspan="4" valign="middle"></td>
                <td rowspan="4" valign="middle">Код<br> рядка</td>
                <td colspan="16" valign="middle">Облікова кількість штатних працівників, осіб</td>
                <td colspan="2" valign="middle">Кількість посад, од.</td>
            </tr>
            <tr valign="top">
                <td rowspan="3" valign="middle">
                    <table class="nested-table">
                        <tbody><tr style="text-rotate: 90">
                            <td><span class="rotate">Усього</span></td>
                            <td><span class="rotate">(гр. 1 .≥ сумі гр. 13–16)</span></td>
                        </tr>
                    </tbody></table>
                </td>
                <td colspan="15" valign="middle">з них</td>
                <td rowspan="3" valign="middle" style="text-rotate: 90"><span class="rotate">за штатним розписом</span></td>
                <td rowspan="3" valign="middle" style="text-rotate: 90"><span class="rotate">фактично зайнятих</span></td>
            </tr>
            <tr valign="top">
                <td rowspan="2" valign="middle">
                    <table class="nested-table">
                        <tbody><tr style="text-rotate: 90">
                            <td><span class="rotate">Жінки (гр. 2 = сумі</span></td>
                            <td><span class="rotate">гр. 3–12)</span></td>
                        </tr>
                    </tbody></table>
                </td>
                <td colspan="10" valign="middle">особи у віці</td>
                <td colspan="4" valign="middle">особи, які мають освітній<br> (освітньо-професійний) ступінь,<br> освітньо-кваліфікаційний рівень</td>
            </tr>
            <tr valign="top">
                <td valign="middle">
                    <table class="nested-table">
                        <tbody><tr style="text-rotate: 90">
                            <td><span class="rotate">менше 25</span></td>
                            <td><span class="rotate">років</span></td>
                        </tr>
                    </tbody></table>
                </td>
                <td valign="middle" style="text-rotate: 90">
                    <span class="rotate">25-29 років</span>
                </td>
                <td valign="middle" style="text-rotate: 90">
                    <span class="rotate">30-34 роки</span>
                </td>
                <td valign="middle" style="text-rotate: 90">
                    <span class="rotate">35-39 років</span>
                </td>
                <td valign="middle" style="text-rotate: 90">
                    <span class="rotate">40-44 роки</span>
                </td>
                <td valign="middle" style="text-rotate: 90">
                    <span class="rotate">45-49 років</span>
                </td>
                <td valign="middle" style="text-rotate: 90">
                    <span class="rotate">50-54 роки</span>
                </td>
                <td valign="middle" style="text-rotate: 90">
                    <span class="rotate">55-59 років</span>
                </td>
                <td valign="middle" style="text-rotate: 90">
                    <span class="rotate">60-64 роки</span>
                </td>
                <td valign="middle">
                    <table class="nested-table">
                        <tbody><tr style="text-rotate: 90">
                            <td><span class="rotate">65 років і</span></td>
                            <td><span class="rotate">більше</span></td>
                        </tr>
                    </tbody></table>
                </td>
                <td valign="middle">
                    <table class="nested-table">
                        <tbody><tr style="text-rotate: 90">
                            <td><span class="rotate">фаховий</span></td>
                            <td><span class="rotate">молодший</span></td>
                            <td><span class="rotate">бакалавр</span></td>
                        </tr>
                    </tbody></table>
                </td>
                <td valign="middle">
                    <table class="nested-table">
                        <tbody><tr style="text-rotate: 90">
                            <td><span class="rotate">молодший</span></td>
                            <td><span class="rotate">бакалавр</span></td>
                            <td><span class="rotate">(молодший</span></td>
                            <td><span class="rotate">спеціаліст)</span></td>
                        </tr>
                    </tbody></table>
                </td>
                <td valign="middle" style="text-rotate: 90">
                    <span class="rotate">бакалавр</span>
                </td>
                <td valign="middle">
                    <table class="nested-table">
                        <tbody><tr style="text-rotate: 90">
                            <td><span class="rotate">магістр</span></td>
                            <td><span class="rotate">(спеціаліст)</span></td>
                        </tr>
                    </tbody></table>
                </td>
            </tr>
            <tr valign="top">
                <td colspan="2" width="17%" valign="middle">А</td>
                <td width="5%" valign="middle">Б</td>
                <td width="4%" valign="middle">1</td>
                <td width="4%" valign="middle">2</td>
                <td width="4%" valign="middle">3</td>
                <td width="4%" valign="middle">4</td>
                <td width="4%" valign="middle">5</td>
                <td width="4%" valign="middle">6</td>
                <td width="4%" valign="middle">7</td>
                <td width="4%" valign="middle">8</td>
                <td width="4%" valign="middle">9</td>
                <td width="4%" valign="middle">10</td>
                <td width="4%" valign="middle">11</td>
                <td width="4%" valign="middle">12</td>
                <td width="6%" valign="middle">13</td>
                <td width="6%" valign="middle">14</td>
                <td width="4%" valign="middle">15</td>
                <td width="4%" valign="middle">16</td>
                <td width="5%" valign="middle">17</td>
                <td width="5%" valign="middle">18</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">
                    Усього<br>
                    (ряд. 1 =  сумі ряд. 2, 21, 22)<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;у тому числі
                </td>
                <td>1</td>
                <td id="r4_1_1" data-k85="PR3001">&nbsp;</td>
                <td id="r4_1_2" data-k85="PR3002">&nbsp;</td>
                <td id="r4_1_3" data-k85="PR13">&nbsp;</td>
                <td id="r4_1_4" data-k85="PR14">&nbsp;</td>
                <td id="r4_1_5" data-k85="PR15">&nbsp;</td>
                <td id="r4_1_6" data-k85="PR16">&nbsp;</td>
                <td id="r4_1_7" data-k85="PR17">&nbsp;</td>
                <td id="r4_1_8" data-k85="PR18">&nbsp;</td>
                <td id="r4_1_9" data-k85="PR19">&nbsp;</td>
                <td id="r4_1_a" data-k85="PR110">&nbsp;</td>
                <td id="r4_1_b" data-k85="PR11165">&nbsp;</td>
                <td id="r4_1_c" data-k85="PR11265">&nbsp;</td>
                <td id="r4_1_d" data-k85="PR113E">&nbsp;</td>
                <td id="r4_1_e" data-k85="PR114E">&nbsp;</td>
                <td id="r4_1_f" data-k85="PR115E">&nbsp;</td>
                <td id="r4_1_g" data-k85="PR116E">&nbsp;</td>
                <td id="r4_1_h" data-k85="PR3007">&nbsp;</td>
                <td id="r4_1_i" data-k85="PR3008">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">
                    Педагогічні працівники<br>
                    (ряд. 2 = сумі ряд. 3–11 та<br>
                    17–23)<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;з них
                </td>
                <td>2</td>
                <td id="r4_2_1" data-k85="PR3101">&nbsp;</td>
                <td id="r4_2_2" data-k85="PR3102">&nbsp;</td>
                <td id="r4_2_3" data-k85="PR23">&nbsp;</td>
                <td id="r4_2_4" data-k85="PR24">&nbsp;</td>
                <td id="r4_2_5" data-k85="PR25">&nbsp;</td>
                <td id="r4_2_6" data-k85="PR26">&nbsp;</td>
                <td id="r4_2_7" data-k85="PR27">&nbsp;</td>
                <td id="r4_2_8" data-k85="PR28">&nbsp;</td>
                <td id="r4_2_9" data-k85="PR29">&nbsp;</td>
                <td id="r4_2_a" data-k85="PR210">&nbsp;</td>
                <td id="r4_2_b" data-k85="PR211">&nbsp;</td>
                <td id="r4_2_c" data-k85="PR212">&nbsp;</td>
                <td id="r4_2_d" data-k85="PR213E">&nbsp;</td>
                <td id="r4_2_e" data-k85="PR214E">&nbsp;</td>
                <td id="r4_2_f" data-k85="PR215E">&nbsp;</td>
                <td id="r4_2_g" data-k85="PR216E">&nbsp;</td>
                <td id="r4_2_h" data-k85="PR3107">&nbsp;</td>
                <td id="r4_2_i" data-k85="PR3108">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    керівники закладів<br>
                    дошкільної освіти<br>
                    (директори, завідувачі)
                </td>
                <td>3</td>
                <td id="r4_3_1" data-k85="PR3111">&nbsp;</td>
                <td id="r4_3_2" data-k85="PR3112">&nbsp;</td>
                <td id="r4_3_3" data-k85="PR33">&nbsp;</td>
                <td id="r4_3_4" data-k85="PR34">&nbsp;</td>
                <td id="r4_3_5" data-k85="PR35">&nbsp;</td>
                <td id="r4_3_6" data-k85="PR36">&nbsp;</td>
                <td id="r4_3_7" data-k85="PR37">&nbsp;</td>
                <td id="r4_3_8" data-k85="PR38">&nbsp;</td>
                <td id="r4_3_9" data-k85="PR39">&nbsp;</td>
                <td id="r4_3_a" data-k85="PR310">&nbsp;</td>
                <td id="r4_3_b" data-k85="PR311">&nbsp;</td>
                <td id="r4_3_c" data-k85="PR312">&nbsp;</td>
                <td id="r4_3_d" data-k85="PR313E">&nbsp;</td>
                <td id="r4_3_e" data-k85="PR314E">&nbsp;</td>
                <td id="r4_3_f" data-k85="PR315E">&nbsp;</td>
                <td id="r4_3_g" data-k85="PR316E">&nbsp;</td>
                <td id="r4_3_h" data-k85="PR3117">&nbsp;</td>
                <td id="r4_3_i" data-k85="PR3118">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    заступники керівників<br>
                    закладів дошкільної<br>
                    освіти з організації<br>
                    освітнього процесу<br>
                    (директорів, завідувачів)
                </td>
                <td>4</td>
                <td id="r4_4_1" data-k85="PR41">&nbsp;</td>
                <td id="r4_4_2" data-k85="PR42">&nbsp;</td>
                <td id="r4_4_3" data-k85="PR43">&nbsp;</td>
                <td id="r4_4_4" data-k85="PR44">&nbsp;</td>
                <td id="r4_4_5" data-k85="PR45">&nbsp;</td>
                <td id="r4_4_6" data-k85="PR46">&nbsp;</td>
                <td id="r4_4_7" data-k85="PR47">&nbsp;</td>
                <td id="r4_4_8" data-k85="PR48">&nbsp;</td>
                <td id="r4_4_9" data-k85="PR49">&nbsp;</td>
                <td id="r4_4_a" data-k85="PR410">&nbsp;</td>
                <td id="r4_4_b" data-k85="PR411">&nbsp;</td>
                <td id="r4_4_c" data-k85="PR412">&nbsp;</td>
                <td id="r4_4_d" data-k85="PR413">&nbsp;</td>
                <td id="r4_4_e" data-k85="PR414">&nbsp;</td>
                <td id="r4_4_f" data-k85="PR415">&nbsp;</td>
                <td id="r4_4_g" data-k85="PR416">&nbsp;</td>
                <td id="r4_4_h" data-k85="PR417">&nbsp;</td>
                <td id="r4_4_i" data-k85="PR418">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    керівники (завідувачі)<br>
                    дошкільних підрозділів
                </td>
                <td>5</td>
                <td id="r4_5_1" data-k85="PR51">&nbsp;</td>
                <td id="r4_5_2" data-k85="PR52">&nbsp;</td>
                <td id="r4_5_3" data-k85="PR53">&nbsp;</td>
                <td id="r4_5_4" data-k85="PR54">&nbsp;</td>
                <td id="r4_5_5" data-k85="PR55">&nbsp;</td>
                <td id="r4_5_6" data-k85="PR56">&nbsp;</td>
                <td id="r4_5_7" data-k85="PR57">&nbsp;</td>
                <td id="r4_5_8" data-k85="PR58">&nbsp;</td>
                <td id="r4_5_9" data-k85="PR59">&nbsp;</td>
                <td id="r4_5_a" data-k85="PR510">&nbsp;</td>
                <td id="r4_5_b" data-k85="PR511">&nbsp;</td>
                <td id="r4_5_c" data-k85="PR512">&nbsp;</td>
                <td id="r4_5_d" data-k85="PR513">&nbsp;</td>
                <td id="r4_5_e" data-k85="PR514">&nbsp;</td>
                <td id="r4_5_f" data-k85="PR515">&nbsp;</td>
                <td id="r4_5_g" data-k85="PR516">&nbsp;</td>
                <td id="r4_5_h" data-k85="PR517">&nbsp;</td>
                <td id="r4_5_i" data-k85="PR518">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    завідувачі філії
                </td>
                <td>6</td>
                <td id="r4_6_1" data-k85="PR61">&nbsp;</td>
                <td id="r4_6_2" data-k85="PR62">&nbsp;</td>
                <td id="r4_6_3" data-k85="PR63">&nbsp;</td>
                <td id="r4_6_4" data-k85="PR64">&nbsp;</td>
                <td id="r4_6_5" data-k85="PR65">&nbsp;</td>
                <td id="r4_6_6" data-k85="PR66">&nbsp;</td>
                <td id="r4_6_7" data-k85="PR67">&nbsp;</td>
                <td id="r4_6_8" data-k85="PR68">&nbsp;</td>
                <td id="r4_6_9" data-k85="PR69">&nbsp;</td>
                <td id="r4_6_a" data-k85="PR610">&nbsp;</td>
                <td id="r4_6_b" data-k85="PR611">&nbsp;</td>
                <td id="r4_6_c" data-k85="PR612">&nbsp;</td>
                <td id="r4_6_d" data-k85="PR613">&nbsp;</td>
                <td id="r4_6_e" data-k85="PR614">&nbsp;</td>
                <td id="r4_6_f" data-k85="PR615">&nbsp;</td>
                <td id="r4_6_g" data-k85="PR616">&nbsp;</td>
                <td id="r4_6_h" data-k85="PR617">&nbsp;</td>
                <td id="r4_6_i" data-k85="PR618">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    вихователі-методисти
                </td>
                <td>7</td>
                <td id="r4_7_1" data-k85="PR3131">&nbsp;</td>
                <td id="r4_7_2" data-k85="PR3132">&nbsp;</td>
                <td id="r4_7_3" data-k85="PR73">&nbsp;</td>
                <td id="r4_7_4" data-k85="PR74">&nbsp;</td>
                <td id="r4_7_5" data-k85="PR75">&nbsp;</td>
                <td id="r4_7_6" data-k85="PR76">&nbsp;</td>
                <td id="r4_7_7" data-k85="PR77">&nbsp;</td>
                <td id="r4_7_8" data-k85="PR78">&nbsp;</td>
                <td id="r4_7_9" data-k85="PR79">&nbsp;</td>
                <td id="r4_7_a" data-k85="PR710">&nbsp;</td>
                <td id="r4_7_b" data-k85="PR711">&nbsp;</td>
                <td id="r4_7_c" data-k85="PR712">&nbsp;</td>
                <td id="r4_7_d" data-k85="PR713">&nbsp;</td>
                <td id="r4_7_e" data-k85="PR714">&nbsp;</td>
                <td id="r4_7_f" data-k85="PR715">&nbsp;</td>
                <td id="r4_7_g" data-k85="PR716">&nbsp;</td>
                <td id="r4_7_h" data-k85="PR717">&nbsp;</td>
                <td id="r4_7_i" data-k85="PR718">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    вихователі
                </td>
                <td>8</td>
                <td id="r4_8_1">&nbsp;</td>
                <td id="r4_8_2" data-k85="PR3122">&nbsp;</td>
                <td id="r4_8_3" data-k85="PR83">&nbsp;</td>
                <td id="r4_8_4" data-k85="PR84">&nbsp;</td>
                <td id="r4_8_5" data-k85="PR85">&nbsp;</td>
                <td id="r4_8_6" data-k85="PR86">&nbsp;</td>
                <td id="r4_8_7" data-k85="PR87">&nbsp;</td>
                <td id="r4_8_8" data-k85="PR88">&nbsp;</td>
                <td id="r4_8_9" data-k85="PR89">&nbsp;</td>
                <td id="r4_8_a" data-k85="PR810">&nbsp;</td>
                <td id="r4_8_b" data-k85="PR811">&nbsp;</td>
                <td id="r4_8_c" data-k85="PR812">&nbsp;</td>
                <td id="r4_8_d" data-k85="PR813">&nbsp;</td>
                <td id="r4_8_e" data-k85="PR814">&nbsp;</td>
                <td id="r4_8_f" data-k85="PR815">&nbsp;</td>
                <td id="r4_8_g" data-k85="PR816">&nbsp;</td>
                <td id="r4_8_h" data-k85="PR817">&nbsp;</td>
                <td id="r4_8_i" data-k85="PR818">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    асистенти вихователів
                </td>
                <td>9</td>
                <td id="r4_9_1" data-k85="PR9061">&nbsp;</td>
                <td id="r4_9_2" data-k85="PR9062">&nbsp;</td>
                <td id="r4_9_3" data-k85="PR93">&nbsp;</td>
                <td id="r4_9_4" data-k85="PR94">&nbsp;</td>
                <td id="r4_9_5" data-k85="PR95">&nbsp;</td>
                <td id="r4_9_6" data-k85="PR96">&nbsp;</td>
                <td id="r4_9_7" data-k85="PR97">&nbsp;</td>
                <td id="r4_9_8" data-k85="PR98">&nbsp;</td>
                <td id="r4_9_9" data-k85="PR99">&nbsp;</td>
                <td id="r4_9_a" data-k85="PR910">&nbsp;</td>
                <td id="r4_9_b" data-k85="PR911">&nbsp;</td>
                <td id="r4_9_c" data-k85="PR912">&nbsp;</td>
                <td id="r4_9_d" data-k85="PR913">&nbsp;</td>
                <td id="r4_9_e" data-k85="PR914">&nbsp;</td>
                <td id="r4_9_f" data-k85="PR915">&nbsp;</td>
                <td id="r4_9_g" data-k85="PR916">&nbsp;</td>
                <td id="r4_9_h" data-k85="PR917">&nbsp;</td>
                <td id="r4_9_i" data-k85="PR918">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    вчителі англійської мови
                </td>
                <td>10</td>
                <td id="r4_10_1" data-k85="PR101">&nbsp;</td>
                <td id="r4_10_2" data-k85="PR102">&nbsp;</td>
                <td id="r4_10_3" data-k85="PR103">&nbsp;</td>
                <td id="r4_10_4" data-k85="PR104">&nbsp;</td>
                <td id="r4_10_5" data-k85="PR105">&nbsp;</td>
                <td id="r4_10_6" data-k85="PR106">&nbsp;</td>
                <td id="r4_10_7" data-k85="PR107">&nbsp;</td>
                <td id="r4_10_8" data-k85="PR108">&nbsp;</td>
                <td id="r4_10_9" data-k85="PR109">&nbsp;</td>
                <td id="r4_10_a" data-k85="PR1010">&nbsp;</td>
                <td id="r4_10_b" data-k85="PR1011">&nbsp;</td>
                <td id="r4_10_c" data-k85="PR1012">&nbsp;</td>
                <td id="r4_10_d" data-k85="PR1013">&nbsp;</td>
                <td id="r4_10_e" data-k85="PR1014">&nbsp;</td>
                <td id="r4_10_f" data-k85="PR1015">&nbsp;</td>
                <td id="r4_10_g" data-k85="PR1016">&nbsp;</td>
                <td id="r4_10_h" data-k85="PR1017">&nbsp;</td>
                <td id="r4_10_i" data-k85="PR1018">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    вчителі-дефектологи<br>
                    (ряд. 11 .≥ сумі ряд. 12–16)
                </td>
                <td>11</td>
                <td id="r4_11_1" data-k85="PR111">&nbsp;</td>
                <td id="r4_11_2" data-k85="PR112">&nbsp;</td>
                <td id="r4_11_3" data-k85="PR113">&nbsp;</td>
                <td id="r4_11_4" data-k85="PR114">&nbsp;</td>
                <td id="r4_11_5" data-k85="PR115">&nbsp;</td>
                <td id="r4_11_6" data-k85="PR116">&nbsp;</td>
                <td id="r4_11_7" data-k85="PR117">&nbsp;</td>
                <td id="r4_11_8" data-k85="PR118">&nbsp;</td>
                <td id="r4_11_9" data-k85="PR119">&nbsp;</td>
                <td id="r4_11_a" data-k85="PR1110">&nbsp;</td>
                <td id="r4_11_b" data-k85="PR1111">&nbsp;</td>
                <td id="r4_11_c" data-k85="PR1112">&nbsp;</td>
                <td id="r4_11_d" data-k85="PR1113">&nbsp;</td>
                <td id="r4_11_e" data-k85="PR1114">&nbsp;</td>
                <td id="r4_11_f" data-k85="PR1115">&nbsp;</td>
                <td id="r4_11_g" data-k85="PR1116">&nbsp;</td>
                <td id="r4_11_h" data-k85="PR1117">&nbsp;</td>
                <td id="r4_11_i" data-k85="PR1118">&nbsp;</td>
            </tr>
    

    

    
            <tr valign="bottom">
                <td rowspan="5" valign="middle" style="text-rotate: 90;">
                    <span class="rotate">в тому числі</span>
                </td>
                <td style="text-align: left;">вчителі-логопеди</td>
                <td>12</td>
                <td id="r4_12_1" data-k85="PR31521">&nbsp;</td>
                <td id="r4_12_2" data-k85="PR31522">&nbsp;</td>
                <td id="r4_12_3" data-k85="PR123">&nbsp;</td>
                <td id="r4_12_4" data-k85="PR124">&nbsp;</td>
                <td id="r4_12_5" data-k85="PR125">&nbsp;</td>
                <td id="r4_12_6" data-k85="PR126">&nbsp;</td>
                <td id="r4_12_7" data-k85="PR127">&nbsp;</td>
                <td id="r4_12_8" data-k85="PR128">&nbsp;</td>
                <td id="r4_12_9" data-k85="PR129">&nbsp;</td>
                <td id="r4_12_a" data-k85="PR1210">&nbsp;</td>
                <td id="r4_12_b" data-k85="PR1211">&nbsp;</td>
                <td id="r4_12_c" data-k85="PR1212">&nbsp;</td>
                <td id="r4_12_d" data-k85="PR1213">&nbsp;</td>
                <td id="r4_12_e" data-k85="PR1214">&nbsp;</td>
                <td id="r4_12_f" data-k85="PR1215">&nbsp;</td>
                <td id="r4_12_g" data-k85="PR1216">&nbsp;</td>
                <td id="r4_12_h" data-k85="PR1217">&nbsp;</td>
                <td id="r4_12_i" data-k85="PR1218">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">сурдопедагоги</td>
                <td>13</td>
                <td id="r4_13_1" data-k85="PR31551">&nbsp;</td>
                <td id="r4_13_2" data-k85="PR31552">&nbsp;</td>
                <td id="r4_13_3" data-k85="PR133">&nbsp;</td>
                <td id="r4_13_4" data-k85="PR134">&nbsp;</td>
                <td id="r4_13_5" data-k85="PR135">&nbsp;</td>
                <td id="r4_13_6" data-k85="PR136">&nbsp;</td>
                <td id="r4_13_7" data-k85="PR137">&nbsp;</td>
                <td id="r4_13_8" data-k85="PR138">&nbsp;</td>
                <td id="r4_13_9" data-k85="PR139">&nbsp;</td>
                <td id="r4_13_a" data-k85="PR1310">&nbsp;</td>
                <td id="r4_13_b" data-k85="PR1311">&nbsp;</td>
                <td id="r4_13_c" data-k85="PR1312">&nbsp;</td>
                <td id="r4_13_d" data-k85="PR1313">&nbsp;</td>
                <td id="r4_13_e" data-k85="PR1314">&nbsp;</td>
                <td id="r4_13_f" data-k85="PR1315">&nbsp;</td>
                <td id="r4_13_g" data-k85="PR1316">&nbsp;</td>
                <td id="r4_13_h" data-k85="PR1317">&nbsp;</td>
                <td id="r4_13_i" data-k85="PR1318">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">корекційні педагоги</td>
                <td>14</td>
                <td id="r4_14_1" data-k85="PR141">&nbsp;</td>
                <td id="r4_14_2" data-k85="PR142">&nbsp;</td>
                <td id="r4_14_3" data-k85="PR143">&nbsp;</td>
                <td id="r4_14_4" data-k85="PR144">&nbsp;</td>
                <td id="r4_14_5" data-k85="PR145">&nbsp;</td>
                <td id="r4_14_6" data-k85="PR146">&nbsp;</td>
                <td id="r4_14_7" data-k85="PR147">&nbsp;</td>
                <td id="r4_14_8" data-k85="PR148">&nbsp;</td>
                <td id="r4_14_9" data-k85="PR149">&nbsp;</td>
                <td id="r4_14_a" data-k85="PR1410">&nbsp;</td>
                <td id="r4_14_b" data-k85="PR1411">&nbsp;</td>
                <td id="r4_14_c" data-k85="PR1412">&nbsp;</td>
                <td id="r4_14_d" data-k85="PR1413">&nbsp;</td>
                <td id="r4_14_e" data-k85="PR1414">&nbsp;</td>
                <td id="r4_14_f" data-k85="PR1415">&nbsp;</td>
                <td id="r4_14_g" data-k85="PR1416">&nbsp;</td>
                <td id="r4_14_h" data-k85="PR1417">&nbsp;</td>
                <td id="r4_14_i" data-k85="PR1418">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">тифлопедагоги</td>
                <td>15</td>
                <td id="r4_15_1" data-k85="PR31531">&nbsp;</td>
                <td id="r4_15_2" data-k85="PR31532">&nbsp;</td>
                <td id="r4_15_3" data-k85="PR153">&nbsp;</td>
                <td id="r4_15_4" data-k85="PR154">&nbsp;</td>
                <td id="r4_15_5" data-k85="PR155">&nbsp;</td>
                <td id="r4_15_6" data-k85="PR156">&nbsp;</td>
                <td id="r4_15_7" data-k85="PR157">&nbsp;</td>
                <td id="r4_15_8" data-k85="PR158">&nbsp;</td>
                <td id="r4_15_9" data-k85="PR159">&nbsp;</td>
                <td id="r4_15_a" data-k85="PR1510">&nbsp;</td>
                <td id="r4_15_b" data-k85="PR1511">&nbsp;</td>
                <td id="r4_15_c" data-k85="PR1512">&nbsp;</td>
                <td id="r4_15_d" data-k85="PR1513">&nbsp;</td>
                <td id="r4_15_e" data-k85="PR1514">&nbsp;</td>
                <td id="r4_15_f" data-k85="PR1515">&nbsp;</td>
                <td id="r4_15_g" data-k85="PR1516">&nbsp;</td>
                <td id="r4_15_h" data-k85="PR1517">&nbsp;</td>
                <td id="r4_15_i" data-k85="PR1518">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">вчителі-реабілітологи</td>
                <td>16</td>
                <td id="r4_16_1" data-k85="PR161">&nbsp;</td>
                <td id="r4_16_2" data-k85="PR162">&nbsp;</td>
                <td id="r4_16_3" data-k85="PR163">&nbsp;</td>
                <td id="r4_16_4" data-k85="PR164">&nbsp;</td>
                <td id="r4_16_5" data-k85="PR165">&nbsp;</td>
                <td id="r4_16_6" data-k85="PR166">&nbsp;</td>
                <td id="r4_16_7" data-k85="PR167">&nbsp;</td>
                <td id="r4_16_8" data-k85="PR168">&nbsp;</td>
                <td id="r4_16_9" data-k85="PR169">&nbsp;</td>
                <td id="r4_16_a" data-k85="PR1610">&nbsp;</td>
                <td id="r4_16_b" data-k85="PR1611">&nbsp;</td>
                <td id="r4_16_c" data-k85="PR1612">&nbsp;</td>
                <td id="r4_16_d" data-k85="PR1613">&nbsp;</td>
                <td id="r4_16_e" data-k85="PR1614">&nbsp;</td>
                <td id="r4_16_f" data-k85="PR1615">&nbsp;</td>
                <td id="r4_16_g" data-k85="PR1616">&nbsp;</td>
                <td id="r4_16_h" data-k85="PR1617">&nbsp;</td>
                <td id="r4_16_i" data-k85="PR1618">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    практичні психологи
                </td>
                <td>17</td>
                <td id="r4_17_1" data-k85="PR3141">&nbsp;</td>
                <td id="r4_17_2" data-k85="PR3142">&nbsp;</td>
                <td id="r4_17_3" data-k85="PR173">&nbsp;</td>
                <td id="r4_17_4" data-k85="PR174">&nbsp;</td>
                <td id="r4_17_5" data-k85="PR175">&nbsp;</td>
                <td id="r4_17_6" data-k85="PR176">&nbsp;</td>
                <td id="r4_17_7" data-k85="PR177">&nbsp;</td>
                <td id="r4_17_8" data-k85="PR178">&nbsp;</td>
                <td id="r4_17_9" data-k85="PR179">&nbsp;</td>
                <td id="r4_17_a" data-k85="PR1710">&nbsp;</td>
                <td id="r4_17_b" data-k85="PR1711">&nbsp;</td>
                <td id="r4_17_c" data-k85="PR1712">&nbsp;</td>
                <td id="r4_17_d" data-k85="PR1713">&nbsp;</td>
                <td id="r4_17_e" data-k85="PR1714">&nbsp;</td>
                <td id="r4_17_f" data-k85="PR1715">&nbsp;</td>
                <td id="r4_17_g" data-k85="PR1716">&nbsp;</td>
                <td id="r4_17_h" data-k85="PR1717">&nbsp;</td>
                <td id="r4_17_i" data-k85="PR1718">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    соціальні педагоги
                </td>
                <td>18</td>
                <td id="r4_18_1" data-k85="PR3151">&nbsp;</td>
                <td id="r4_18_2" data-k85="PR3152">&nbsp;</td>
                <td id="r4_18_3" data-k85="PR183">&nbsp;</td>
                <td id="r4_18_4" data-k85="PR184">&nbsp;</td>
                <td id="r4_18_5" data-k85="PR185">&nbsp;</td>
                <td id="r4_18_6" data-k85="PR186">&nbsp;</td>
                <td id="r4_18_7" data-k85="PR187">&nbsp;</td>
                <td id="r4_18_8" data-k85="PR188">&nbsp;</td>
                <td id="r4_18_9" data-k85="PR189">&nbsp;</td>
                <td id="r4_18_a" data-k85="PR1810">&nbsp;</td>
                <td id="r4_18_b" data-k85="PR1811">&nbsp;</td>
                <td id="r4_18_c" data-k85="PR1812">&nbsp;</td>
                <td id="r4_18_d" data-k85="PR1813">&nbsp;</td>
                <td id="r4_18_e" data-k85="PR1814">&nbsp;</td>
                <td id="r4_18_f" data-k85="PR1815">&nbsp;</td>
                <td id="r4_18_g" data-k85="PR1816">&nbsp;</td>
                <td id="r4_18_h" data-k85="PR1817">&nbsp;</td>
                <td id="r4_18_i" data-k85="PR1818">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    інструктори з фізичної<br> культури
                </td>
                <td>19</td>
                <td id="r4_19_1" data-k85="PR31071">&nbsp;</td>
                <td id="r4_19_2" data-k85="PR31072">&nbsp;</td>
                <td id="r4_19_3" data-k85="PR193">&nbsp;</td>
                <td id="r4_19_4" data-k85="PR194">&nbsp;</td>
                <td id="r4_19_5" data-k85="PR195">&nbsp;</td>
                <td id="r4_19_6" data-k85="PR196">&nbsp;</td>
                <td id="r4_19_7" data-k85="PR197">&nbsp;</td>
                <td id="r4_19_8" data-k85="PR198">&nbsp;</td>
                <td id="r4_19_9" data-k85="PR199">&nbsp;</td>
                <td id="r4_19_a" data-k85="PR1910">&nbsp;</td>
                <td id="r4_19_b" data-k85="PR1911">&nbsp;</td>
                <td id="r4_19_c" data-k85="PR1912">&nbsp;</td>
                <td id="r4_19_d" data-k85="PR1913">&nbsp;</td>
                <td id="r4_19_e" data-k85="PR1914">&nbsp;</td>
                <td id="r4_19_f" data-k85="PR1915">&nbsp;</td>
                <td id="r4_19_g" data-k85="PR1916">&nbsp;</td>
                <td id="r4_19_h" data-k85="PR1917">&nbsp;</td>
                <td id="r4_19_i" data-k85="PR1918">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    інструктори слухових<br> кабінетів
                </td>
                <td>20</td>
                <td id="r4_20_1" data-k85="PR201">&nbsp;</td>
                <td id="r4_20_2" data-k85="PR202">&nbsp;</td>
                <td id="r4_20_3" data-k85="PR203">&nbsp;</td>
                <td id="r4_20_4" data-k85="PR204">&nbsp;</td>
                <td id="r4_20_5" data-k85="PR205">&nbsp;</td>
                <td id="r4_20_6" data-k85="PR206">&nbsp;</td>
                <td id="r4_20_7" data-k85="PR207">&nbsp;</td>
                <td id="r4_20_8" data-k85="PR208">&nbsp;</td>
                <td id="r4_20_9" data-k85="PR209">&nbsp;</td>
                <td id="r4_20_a" data-k85="PR2010">&nbsp;</td>
                <td id="r4_20_b" data-k85="PR2011">&nbsp;</td>
                <td id="r4_20_c" data-k85="PR2012">&nbsp;</td>
                <td id="r4_20_d" data-k85="PR2013">&nbsp;</td>
                <td id="r4_20_e" data-k85="PR2014">&nbsp;</td>
                <td id="r4_20_f" data-k85="PR2015">&nbsp;</td>
                <td id="r4_20_g" data-k85="PR2016">&nbsp;</td>
                <td id="r4_20_h" data-k85="PR2017">&nbsp;</td>
                <td id="r4_20_i" data-k85="PR2018">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    музичні керівники
                </td>
                <td>21</td>
                <td id="r4_21_1" data-k85="PR31081">&nbsp;</td>
                <td id="r4_21_2" data-k85="PR31082">&nbsp;</td>
                <td id="r4_21_3" data-k85="PR213">&nbsp;</td>
                <td id="r4_21_4" data-k85="PR214">&nbsp;</td>
                <td id="r4_21_5" data-k85="PR215">&nbsp;</td>
                <td id="r4_21_6" data-k85="PR216">&nbsp;</td>
                <td id="r4_21_7" data-k85="PR217">&nbsp;</td>
                <td id="r4_21_8" data-k85="PR218">&nbsp;</td>
                <td id="r4_21_9" data-k85="PR219">&nbsp;</td>
                <td id="r4_21_a" data-k85="PR2110">&nbsp;</td>
                <td id="r4_21_b" data-k85="PR2111">&nbsp;</td>
                <td id="r4_21_c" data-k85="PR2112">&nbsp;</td>
                <td id="r4_21_d" data-k85="PR2113">&nbsp;</td>
                <td id="r4_21_e" data-k85="PR2114">&nbsp;</td>
                <td id="r4_21_f" data-k85="PR2115">&nbsp;</td>
                <td id="r4_21_g" data-k85="PR2116">&nbsp;</td>
                <td id="r4_21_h" data-k85="PR2117">&nbsp;</td>
                <td id="r4_21_i" data-k85="PR2118">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    керівники гуртків,<br> студій, секцій тощо
                </td>
                <td>22</td>
                <td id="r4_22_1" data-k85="PR31091">&nbsp;</td>
                <td id="r4_22_2" data-k85="PR31092">&nbsp;</td>
                <td id="r4_22_3" data-k85="PR223">&nbsp;</td>
                <td id="r4_22_4" data-k85="PR224">&nbsp;</td>
                <td id="r4_22_5" data-k85="PR225">&nbsp;</td>
                <td id="r4_22_6" data-k85="PR226">&nbsp;</td>
                <td id="r4_22_7" data-k85="PR227">&nbsp;</td>
                <td id="r4_22_8" data-k85="PR228">&nbsp;</td>
                <td id="r4_22_9" data-k85="PR229">&nbsp;</td>
                <td id="r4_22_a" data-k85="PR2210">&nbsp;</td>
                <td id="r4_22_b" data-k85="PR2211">&nbsp;</td>
                <td id="r4_22_c" data-k85="PR2212">&nbsp;</td>
                <td id="r4_22_d" data-k85="PR2213">&nbsp;</td>
                <td id="r4_22_e" data-k85="PR2214">&nbsp;</td>
                <td id="r4_22_f" data-k85="PR2215">&nbsp;</td>
                <td id="r4_22_g" data-k85="PR2216">&nbsp;</td>
                <td id="r4_22_h" data-k85="PR2217">&nbsp;</td>
                <td id="r4_22_i" data-k85="PR2218">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    інші педагогічні<br> працівники
                </td>
                <td>23</td>
                <td id="r4_23_1" data-k85="PR3161">&nbsp;</td>
                <td id="r4_23_2" data-k85="PR3162">&nbsp;</td>
                <td id="r4_23_3" data-k85="PR233">&nbsp;</td>
                <td id="r4_23_4" data-k85="PR234">&nbsp;</td>
                <td id="r4_23_5" data-k85="PR235">&nbsp;</td>
                <td id="r4_23_6" data-k85="PR236">&nbsp;</td>
                <td id="r4_23_7" data-k85="PR237">&nbsp;</td>
                <td id="r4_23_8" data-k85="PR238">&nbsp;</td>
                <td id="r4_23_9" data-k85="PR239">&nbsp;</td>
                <td id="r4_23_a" data-k85="PR2310">&nbsp;</td>
                <td id="r4_23_b" data-k85="PR2311">&nbsp;</td>
                <td id="r4_23_c" data-k85="PR2312">&nbsp;</td>
                <td id="r4_23_d" data-k85="PR2313">&nbsp;</td>
                <td id="r4_23_e" data-k85="PR2314">&nbsp;</td>
                <td id="r4_23_f" data-k85="PR2315">&nbsp;</td>
                <td id="r4_23_g" data-k85="PR2316">&nbsp;</td>
                <td id="r4_23_h" data-k85="PR2317">&nbsp;</td>
                <td id="r4_23_i" data-k85="PR2318">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    медичні працівники
                </td>
                <td>24</td>
                <td id="r4_24_1" data-k85="PR3201">&nbsp;</td>
                <td id="r4_24_2" data-k85="PR3202">&nbsp;</td>
                <td id="r4_24_3" data-k85="PR243">&nbsp;</td>
                <td id="r4_24_4" data-k85="PR244">&nbsp;</td>
                <td id="r4_24_5" data-k85="PR245">&nbsp;</td>
                <td id="r4_24_6" data-k85="PR246">&nbsp;</td>
                <td id="r4_24_7" data-k85="PR247">&nbsp;</td>
                <td id="r4_24_8" data-k85="PR248">&nbsp;</td>
                <td id="r4_24_9" data-k85="PR249">&nbsp;</td>
                <td id="r4_24_a" data-k85="PR2410">&nbsp;</td>
                <td id="r4_24_b" data-k85="PR2411">&nbsp;</td>
                <td id="r4_24_c" data-k85="PR2412">&nbsp;</td>
                <td id="r4_24_d" data-k85="PR2413">&nbsp;</td>
                <td id="r4_24_e" data-k85="PR2414">&nbsp;</td>
                <td id="r4_24_f" data-k85="PR2415">&nbsp;</td>
                <td id="r4_24_g" data-k85="PR2416">&nbsp;</td>
                <td id="r4_24_h" data-k85="PR2417">&nbsp;</td>
                <td id="r4_24_i" data-k85="PR2418">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    технічний працівники
                </td>
                <td>25</td>
                <td id="r4_25_1" data-k85="PR3301">&nbsp;</td>
                <td id="r4_25_2" data-k85="PR3302">&nbsp;</td>
                <td id="r4_25_3" data-k85="PR253">&nbsp;</td>
                <td id="r4_25_4" data-k85="PR254">&nbsp;</td>
                <td id="r4_25_5" data-k85="PR255">&nbsp;</td>
                <td id="r4_25_6" data-k85="PR256">&nbsp;</td>
                <td id="r4_25_7" data-k85="PR257">&nbsp;</td>
                <td id="r4_25_8" data-k85="PR258">&nbsp;</td>
                <td id="r4_25_9" data-k85="PR259">&nbsp;</td>
                <td id="r4_25_a" data-k85="PR2510">&nbsp;</td>
                <td id="r4_25_b" data-k85="PR2511">&nbsp;</td>
                <td id="r4_25_c" data-k85="PR2512">&nbsp;</td>
                <td id="r4_25_d" data-k85="PR2513">&nbsp;</td>
                <td id="r4_25_e" data-k85="PR2514">&nbsp;</td>
                <td id="r4_25_f" data-k85="PR2515">&nbsp;</td>
                <td id="r4_25_g" data-k85="PR2516">&nbsp;</td>
                <td id="r4_25_h" data-k85="PR2517">&nbsp;</td>
                <td id="r4_25_i" data-k85="PR2518">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    Із рядка 2:
                </td>
                <td>26</td>
                <td id="r4_26_1">&nbsp;</td>
                <td id="r4_26_2">&nbsp;</td>
                <td id="r4_26_3">&nbsp;</td>
                <td id="r4_26_4">&nbsp;</td>
                <td id="r4_26_5">&nbsp;</td>
                <td id="r4_26_6">&nbsp;</td>
                <td id="r4_26_7">&nbsp;</td>
                <td id="r4_26_8">&nbsp;</td>
                <td id="r4_26_9">&nbsp;</td>
                <td id="r4_26_a">&nbsp;</td>
                <td id="r4_26_b">&nbsp;</td>
                <td id="r4_26_c">&nbsp;</td>
                <td id="r4_26_d">&nbsp;</td>
                <td id="r4_26_e">&nbsp;</td>
                <td id="r4_26_f">&nbsp;</td>
                <td id="r4_26_g">&nbsp;</td>
                <td id="r4_26_h">&nbsp;</td>
                <td id="r4_26_i">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    жінки
                </td>
                <td>27</td>
                <td id="r4_27_1" data-k85="PR271">&nbsp;</td>
                <td id="r4_27_2" data-k85="PR272">&nbsp;</td>
                <td id="r4_27_3" data-k85="PR273">&nbsp;</td>
                <td id="r4_27_4" data-k85="PR274">&nbsp;</td>
                <td id="r4_27_5" data-k85="PR275">&nbsp;</td>
                <td id="r4_27_6" data-k85="PR276">&nbsp;</td>
                <td id="r4_27_7" data-k85="PR277">&nbsp;</td>
                <td id="r4_27_8" data-k85="PR278">&nbsp;</td>
                <td id="r4_27_9" data-k85="PR279">&nbsp;</td>
                <td id="r4_27_a" data-k85="PR2710">&nbsp;</td>
                <td id="r4_27_b" data-k85="PR2711">&nbsp;</td>
                <td id="r4_27_c" data-k85="PR2712">&nbsp;</td>
                <td id="r4_27_d" data-k85="PR2713">&nbsp;</td>
                <td id="r4_27_e" data-k85="PR2714">&nbsp;</td>
                <td id="r4_27_f" data-k85="PR2715">&nbsp;</td>
                <td id="r4_27_g" data-k85="PR2716">&nbsp;</td>
                
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    працюють з дітьми до<br> 3 років
                </td>
                <td>28</td>
                <td id="r4_28_1" data-k85="PR281">&nbsp;</td>
                <td id="r4_28_2" data-k85="PR282">&nbsp;</td>
                <td id="r4_28_3" data-k85="PR283">&nbsp;</td>
                <td id="r4_28_4" data-k85="PR284">&nbsp;</td>
                <td id="r4_28_5" data-k85="PR285">&nbsp;</td>
                <td id="r4_28_6" data-k85="PR286">&nbsp;</td>
                <td id="r4_28_7" data-k85="PR287">&nbsp;</td>
                <td id="r4_28_8" data-k85="PR288">&nbsp;</td>
                <td id="r4_28_9" data-k85="PR289">&nbsp;</td>
                <td id="r4_28_a" data-k85="PR2810">&nbsp;</td>
                <td id="r4_28_b" data-k85="PR2811">&nbsp;</td>
                <td id="r4_28_c" data-k85="PR2812">&nbsp;</td>
                <td id="r4_28_d" data-k85="PR2813">&nbsp;</td>
                <td id="r4_28_e" data-k85="PR2814">&nbsp;</td>
                <td id="r4_28_f" data-k85="PR2815">&nbsp;</td>
                <td id="r4_28_g" data-k85="PR2816">&nbsp;</td>
                
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    працюють з дітьми<br> старше 3  років
                </td>
                <td>29</td>
                <td id="r4_29_1" data-k85="PR291">&nbsp;</td>
                <td id="r4_29_2" data-k85="PR292">&nbsp;</td>
                <td id="r4_29_3" data-k85="PR293">&nbsp;</td>
                <td id="r4_29_4" data-k85="PR294">&nbsp;</td>
                <td id="r4_29_5" data-k85="PR295">&nbsp;</td>
                <td id="r4_29_6" data-k85="PR296">&nbsp;</td>
                <td id="r4_29_7" data-k85="PR297">&nbsp;</td>
                <td id="r4_29_8" data-k85="PR298">&nbsp;</td>
                <td id="r4_29_9" data-k85="PR299">&nbsp;</td>
                <td id="r4_29_a" data-k85="PR2910">&nbsp;</td>
                <td id="r4_29_b" data-k85="PR2911">&nbsp;</td>
                <td id="r4_29_c" data-k85="PR2912">&nbsp;</td>
                <td id="r4_29_d" data-k85="PR2913">&nbsp;</td>
                <td id="r4_29_e" data-k85="PR2914">&nbsp;</td>
                <td id="r4_29_f" data-k85="PR2915">&nbsp;</td>
                <td id="r4_29_g" data-k85="PR2916">&nbsp;</td>
               
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    Мають педагогічне<br> навантаження менше<br> норми
                </td>
                <td>30</td>
                <td id="r4_30_1" data-k85="PR301">&nbsp;</td>
                <td id="r4_30_2" data-k85="PR302">&nbsp;</td>
                <td id="r4_30_3" data-k85="PR303">&nbsp;</td>
                <td id="r4_30_4" data-k85="PR304">&nbsp;</td>
                <td id="r4_30_5" data-k85="PR305">&nbsp;</td>
                <td id="r4_30_6" data-k85="PR306">&nbsp;</td>
                <td id="r4_30_7" data-k85="PR307">&nbsp;</td>
                <td id="r4_30_8" data-k85="PR308">&nbsp;</td>
                <td id="r4_30_9" data-k85="PR309">&nbsp;</td>
                <td id="r4_30_a" data-k85="PR3010">&nbsp;</td>
                <td id="r4_30_b" data-k85="PR3011">&nbsp;</td>
                <td id="r4_30_c" data-k85="PR3012">&nbsp;</td>
                <td id="r4_30_d" data-k85="PR3013">&nbsp;</td>
                <td id="r4_30_e" data-k85="PR3014">&nbsp;</td>
                <td id="r4_30_f" data-k85="PR3015">&nbsp;</td>
                <td id="r4_30_g" data-k85="PR3016">&nbsp;</td>
               
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 25px;">
                    Підвищили кваліфікацію<br> з підтримки дітей з ООП
                </td>
                <td>31</td>
                <td id="r4_31_1" data-k85="PR3501">&nbsp;</td>
                <td id="r4_31_2" data-k85="PR3502">&nbsp;</td>
                <td id="r4_31_3" data-k85="PR313">&nbsp;</td>
                <td id="r4_31_4" data-k85="PR314">&nbsp;</td>
                <td id="r4_31_5" data-k85="PR315">&nbsp;</td>
                <td id="r4_31_6" data-k85="PR316">&nbsp;</td>
                <td id="r4_31_7" data-k85="PR317">&nbsp;</td>
                <td id="r4_31_8" data-k85="PR318">&nbsp;</td>
                <td id="r4_31_9" data-k85="PR319">&nbsp;</td>
                <td id="r4_31_a" data-k85="PR31101">&nbsp;</td>
                <td id="r4_31_b" data-k85="PR31111">&nbsp;</td>
                <td id="r4_31_c" data-k85="PR31121">&nbsp;</td>
                <td id="r4_31_d" data-k85="PR3113">&nbsp;</td>
                <td id="r4_31_e" data-k85="PR3114">&nbsp;</td>
                <td id="r4_31_f" data-k85="PR31151">&nbsp;</td>
                <td id="r4_31_g" data-k85="PR31161">&nbsp;</td>
                <td id="r4_31_h" >&nbsp;</td>
                <td id="r4_31_i" >&nbsp;</td>
            </tr>
        </tbody></table>
    </div>

    <div style="clear: both; float: none;"></div>
    

    <h1 class="rvps5" style="position:relative;">
        <span class="rvts8" style="font-size: 14pt; text-align: center;">
            Розділ V. Розподіл дітей у групах за мовами виховання на кінець звітного року
        </span>
    </h1>

    <div align="center" style="margin-top: -8px;">
        <table align="left" width="100%" border="1" cellpadding="0" cellspacing="0" style="border-width: 0px; border-collapse: collapse; font-size: 10pt; text-align: center; white-space: nowrap;" class="nopadding">
            <tbody><tr valign="top">
                <td width="40%"></td>
                <td width="10%">Код рядка</td>
                <td width="25%">Кількість груп, од.</td>
                <td width="25%">Кількість дітей, осіб</td>
            </tr>
            <tr valign="top">
                <td>А</td>
                <td>Б</td>
                <td>1</td>
                <td>2</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;">
                    Усі мови виховання<br>
                    (ряд. 1 =  сумі ряд. 2–14)<br>
                    у тому числі:
                </td>
                <td>1</td>
                <td id="r5_1_1" data-k85="LNG11">&nbsp;</td>
                <td id="r5_1_2" data-k85="LNG4000">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 15px;">українська</td>
                <td>2</td>
                <td id="r5_2_1" data-k85="LNG12">&nbsp;</td>
                <td id="r5_2_2" data-k85="LNG4010">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 15px;">англійська</td>
                <td>3</td>
                <td id="r5_3_1" data-k85="LNG13">&nbsp;</td>
                <td id="r5_3_2" data-k85="LNG4030">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 15px;">болгарська</td>
                <td>4</td>
                <td id="r5_4_1" data-k85="LNG14">&nbsp;</td>
                <td id="r5_4_2" data-k85="LNG4040">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 15px;">гагаузька</td>
                <td>5</td>
                <td id="r5_5_1" data-k85="LNG15">&nbsp;</td>
                <td id="r5_5_2" data-k85="LNG25">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 15px;">їдиш або іврит</td>
                <td>6</td>
                <td id="r5_6_1" data-k85="LNG16">&nbsp;</td>
                <td id="r5_6_2" data-k85="LNG26">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 15px;">кримськотатарська</td>
                <td>7</td>
                <td id="r5_7_1" data-k85="LNG17">&nbsp;</td>
                <td id="r5_7_2" data-k85="LNG4050">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 15px;">німецька</td>
                <td>8</td>
                <td id="r5_8_1" data-k85="LNG18">&nbsp;</td>
                <td id="r5_8_2" data-k85="LNG4070">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 15px;">польська</td>
                <td>9</td>
                <td id="r5_9_1" data-k85="LNG19">&nbsp;</td>
                <td id="r5_9_2" data-k85="LNG4080">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 15px;">румунська</td>
                <td>10</td>
                <td id="r5_10_1" data-k85="LNG110">&nbsp;</td>
                <td id="r5_10_2" data-k85="LNG4090">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 15px;">словацька</td>
                <td>11</td>
                <td id="r5_11_1" data-k85="LNG111">&nbsp;</td>
                <td id="r5_11_2" data-k85="LNG4100">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 15px;">угорська</td>
                <td>12</td>
                <td id="r5_12_1" data-k85="LNG112">&nbsp;</td>
                <td id="r5_12_2" data-k85="LNG4110">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 15px;">чеська</td>
                <td>13</td>
                <td id="r5_13_1" data-k85="LNG113">&nbsp;</td>
                <td id="r5_13_2" data-k85="LNG213">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 15px;">інші</td>
                <td>14</td>
                <td id="r5_14_1" data-k85="LNG114">&nbsp;</td>
                <td id="r5_14_2" data-k85="LNG214">&nbsp;</td>
            </tr>
        </tbody></table>
    </div>

    <h1 class="rvps5" style="position:relative;">
        <span class="rvts8" style="font-size: 14pt; text-align: center;">
            Розділ VI. Відомості про матеріально-технічну базу закладу дошкільної освіти
            на кінець звітного року
        </span>
    </h1>

    <div align="center" style="margin-top: -8px;">
        <table align="left" width="100%" border="1" cellpadding="0" cellspacing="0" style="border-width: 0px; border-collapse: collapse;font-size: 10pt; text-align: center;white-space: nowrap;" class="nopadding">
            <tbody><tr valign="top">
                <td colspan="2" width="80%"></td>
                <td width="8%">Код<br> рядка</td>
                <td width="12%">Значення</td>
            </tr>
            <tr valign="top">
                <td colspan="2">А</td>
                <td>Б</td>
                <td>1</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Проєктна потужність закладу, місць</td>
                <td>1</td>
                <td id="r6_1_1" data-k85="BD5000">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Чи здається частина площі в оренду  (1 - так; 0 - ні)</td>
                <td>2</td>
                <td id="r6_2_1" data-k85="BD5010">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Тип приміщень закладу (1 - власні; 2 - орендовані; 3 - частково орендовані)</td>
                <td>3</td>
                <td id="r6_3_1" data-k85="BD5020">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Власна територія для організації прогулянок на свіжому повітрі  (1 - так; 0 - ні)</td>
                <td>4</td>
                <td id="r6_4_1" data-k85="BD5030">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Музична зала  (1 - так; 0 - ні)</td>
                <td>5</td>
                <td id="r6_5_1" data-k85="BD5040">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Фізкультурна зала  (1 - так; 0 - ні)</td>
                <td>6</td>
                <td id="r6_6_1" data-k85="BD5050">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Ресурсна кімната  (1 - так; 0 - ні)</td>
                <td>7</td>
                <td id="r6_7_1" data-k85="BD5060">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Басейн  (1 - так; 0 - ні)</td>
                <td>8</td>
                <td id="r6_8_1" data-k85="BD5070">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Опалення (1 - централізоване або індивідуальне опалення; 2 – пічне)</td>
                <td>9</td>
                <td id="r6_9_1" data-k85="BD5080">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Каналізація  (1 - так; 0 - ні)</td>
                <td>10</td>
                <td id="r6_10_1" data-k85="BD5090">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Водогін  (1 - так; 0 - ні)</td>
                <td>11</td>
                <td id="r6_11_1" data-k85="BD5100">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left; padding-left: 15px;">з гарячою водою  (1 - так; 0 - ні)</td>
                <td>12</td>
                <td id="r6_12_1" data-k85="BD5101">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Пандуси та поручні  (1 - так; 0 - ні)</td>
                <td>13</td>
                <td id="r6_13_1" data-k85="BD5110">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Ліфти (підйомники)  (1 - так; 0 - ні)</td>
                <td>14</td>
                <td id="r6_14_1" data-k85="BD5120">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Спеціально обладнані туалетні кімнати для осіб з інвалідністю  (1 - так; 0 - ні)</td>
                <td>15</td>
                <td id="r6_15_1" data-k85="BD5130">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Кількість поверхів в основній будівлі закладу, од.</td>
                <td>16</td>
                <td id="r6_16_1" data-k85="BD5140">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">До якого поверху є безперешкодний доступ осіб з інвалідністю</td>
                <td>17</td>
                <td id="r6_17_1" data-k85="BD5150">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Кількість окремих будівель, од. (ряд 18 ≥ сумі ряд. 19, 20)</td>
                <td>18</td>
                <td id="r6_18_1" data-k85="BD5160">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td rowspan="2" style="text-align: center;">з них</td>
                <td style="text-align: left; padding-left: 15px;">потребують капітального ремонту</td>
                <td>19</td>
                <td id="r6_19_1" data-k85="BD5161">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 15px;">перебувають в аварійному стані</td>
                <td>20</td>
                <td id="r6_20_1" data-k85="BD5162">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">
                    Наявність захисної споруди цивільного захисту (укриття)<br>
                    (1 - власне; 2 - орендоване; 3 – інший тип використання; 0 - відсутнє)
                </td>
                <td>21</td>
                <td id="r6_21_1" data-k85="BD21">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">
                    Тип укриття (1 – найпростіше; 2 – протирадіаційне; 3 –  споруда подвійного<br>
                    призначення з властивостями сховища; 4 – споруда подвійного призначення з<br>
                    протирадіаційними властивостями; 5 – сховище; 6 – модульне)
                </td>
                <td>22</td>
                <td id="r6_22_1" data-k85="BD22">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Площа укриття, м2</td>
                <td>23</td>
                <td id="r6_23_1" data-k85="BD23">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Місткість укриття, осіб</td>
                <td>24</td>
                <td id="r6_24_1" data-k85="BD24">&nbsp;</td>
            </tr>
        </tbody></table>
    </div>
    <div style="clear: both; float: none;"></div>

    

    <h1 class="rvps5" style="position:relative;"><span class="rvts8" style="font-size: 14pt; text-align: center;">
            Розділ VІI. Відомості про використання сучасних інформаційних технологій
            на кінець звітного року
        </span>
    </h1>

    <div align="center" style="margin-top: -8px;">
        <table align="left" width="100%" border="1" cellpadding="0" cellspacing="0" style="border-width: 0px; border-collapse: collapse;font-size: 10pt; text-align: center;white-space: nowrap;" class="nopadding">
            <tbody><tr valign="top">
                <td colspan="2" width="75%"></td>
                <td width="10%">Код<br> рядка</td>
                <td width="15%">Значення</td>
            </tr>
            <tr valign="top">
                <td colspan="2">А</td>
                <td>Б</td>
                <td>1</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Кількість персональних комп’ютерів, усього, од.</td>
                <td>1</td>
                <td id="r7_1_1" data-k85="PC6100">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td rowspan="6" valign="middle">з них</td>
                <td style="text-align: left; padding-left: 25px;">придбано за кошти бюджету</td>
                <td>2</td>
                <td id="r7_2_1" data-k85="PC6110">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left: 25px;">не працюють</td>
                <td>3</td>
                <td id="r7_3_1" data-k85="PC6120">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left: 25px;">термін придбання становить понад 5 років</td>
                <td>4</td>
                <td id="r7_4_1" data-k85="PC6130">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left: 25px;">використовуються в управлінсько-господарській діяльності</td>
                <td>5</td>
                <td id="r7_5_1" data-k85="PC6140">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left: 25px;">підключено до Інтернет</td>
                <td>6</td>
                <td id="r7_6_1" data-k85="PC6150">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left: 25px;">підключено до Wi-Fi</td>
                <td>7</td>
                <td id="r7_7_1" data-k85="PC6160">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Кількість портативних комп’ютерів, ноутбуків, нетбуків, од.</td>
                <td>8</td>
                <td id="r7_8_1" data-k85="PC6170">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Кількість планшетів, од.</td>
                <td>9</td>
                <td id="r7_9_1" data-k85="PC6180">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Кількість інтерактивних комплексів, усього, од.</td>
                <td>10</td>
                <td id="r7_10_1" data-k85="PC6200">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td rowspan="3" valign="middle">з них</td>
                <td style="text-align: left;padding-left: 25px;">проєкторів та інтерактивних дошок</td>
                <td>11</td>
                <td id="r7_11_1" data-k85="PC6210">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left: 25px;">проєкторів з інтерактивним модулем</td>
                <td>12</td>
                <td id="r7_12_1" data-k85="PC6220">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left: 25px;">інтерактивних дисплеїв</td>
                <td>13</td>
                <td id="r7_13_1" data-k85="PC6230">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Кількість засобів візуалізації (без інтерактиву), усього, од.</td>
                <td>14</td>
                <td id="r7_14_1" data-k85="PC6300">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td rowspan="3" valign="middle">з них</td>
                <td style="text-align: left;padding-left: 25px;">проєкторів</td>
                <td>15</td>
                <td id="r7_15_1" data-k85="PC6310">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left: 25px;">телевізорів</td>
                <td>16</td>
                <td id="r7_16_1" data-k85="PC6320">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left;padding-left: 25px;">інше</td>
                <td>17</td>
                <td id="r7_17_1" data-k85="PC6330">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Кількість принтерів, од.</td>
                <td>18</td>
                <td id="r7_18_1" data-k85="PC6400">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">
                    Наявність у закладі системного адміністратора (інженера з обслуговування<br>
                    ПК, локальної мережі тощо) (1 - так; 0 - ні)
                </td>
                <td>19</td>
                <td id="r7_19_1" data-k85="PC19">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td colspan="2" style="text-align: left;">Наявність інтернету (1 - так; 0 - ні)</td>
                <td>20</td>
                <td id="r7_20_1" data-k85="PC20">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td rowspan="4" style="text-align: left;">
                    Швидкість фіксованого<br>
                    широкосмугового доступу до<br>
                    інтернету<br>
                    (1 - так; 0 - ні)
                </td>
                <td style="text-align: left; padding-left: 25px;">до 10 Мбіт/с</td>
                <td>21</td>
                <td id="r7_21_1" data-k85="PC6510">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 25px;">від 10 до 30 Мбіт/с</td>
                <td>22</td>
                <td id="r7_22_1" data-k85="PC6520">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 25px;">від 30 до 100 Мбіт/с</td>
                <td>23</td>
                <td id="r7_23_1" data-k85="PC6530">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 25px;">100 і більше Мбіт/с</td>
                <td>24</td>
                <td id="r7_24_1" data-k85="PC6540">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td rowspan="4" style="text-align: left;">
                    Швидкість безпроводового<br>
                    широкосмугового доступу до<br>
                    інтернету<br>
                    (1 - так; 0 - ні)
                </td>
                <td style="text-align: left; padding-left: 25px;">до 10 Мбіт/с</td>
                <td>25</td>
                <td id="r7_25_1" data-k85="PC6610">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 25px;">від 10 до 30 Мбіт/с</td>
                <td>26</td>
                <td id="r7_26_1" data-k85="PC6620">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 25px;">від 30 до 100 Мбіт/с</td>
                <td>27</td>
                <td id="r7_27_1" data-k85="PC6630">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 25px;">100 і більше Мбіт/с</td>
                <td>28</td>
                <td id="r7_28_1" data-k85="PC6640">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td rowspan="3" style="text-align: left;">
                    Потреба у пристроях для<br>
                    навчання, од.
                </td>
                <td style="text-align: left; padding-left: 25px;">ПК</td>
                <td>29</td>
                <td id="r7_29_1" data-k85="PC29">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 25px;">ноутбуки</td>
                <td>30</td>
                <td id="r7_30_1" data-k85="PC30">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 25px;">планшети</td>
                <td>31</td>
                <td id="r7_31_1" data-k85="PC31">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td rowspan="2" style="text-align: left;">
                    Потреба у ліцензійному<br>
                    програмному забезпеченні, од.
                </td>
                <td style="text-align: left; padding-left: 25px;">операційні системи</td>
                <td>32</td>
                <td id="r7_32_1" data-k85="PC32">&nbsp;</td>
            </tr>
            <tr valign="bottom">
                <td style="text-align: left; padding-left: 25px;">пакет програмних засобів офісного<br> призначення</td>
                <td>33</td>
                <td id="r7_33_1" data-k85="PC33">&nbsp;</td>
            </tr>
        </tbody></table>
    </div>
    <br>
    <div align="left" style="font-size: 10pt;" class="after-table-fields">
        <p style="text-indent: 20px; line-height: 1.5">З рядків 1, 8 та 9 кількість пристроїв з операційною системою, од.: Microsoft Windows <u><span data-k85="PCOSWIN">&nbsp;</span></u> (34), <br>
        Mac OS <u><span data-k85="PCOSMAC">&nbsp;</span></u> (35), хмарні операційні системи <u><span data-k85="PCOSCLOUD">&nbsp;</span></u> (36), Android <u><span data-k85="PCOSANDROID">&nbsp;</span></u> (37), iOS <u><span data-k85="PCOSIOS">&nbsp;</span></u> (38), інші <u><span data-k85="PCOSOTHER">&nbsp;</span></u> (39).</p>
    </div>

    <div style="clear: both; float: none;"></div>

    
</pagebreak></pagebreak></pagebreak></div>

</sethtmlpageheader>`;

export default K85_FORM_HTML;